!function(e) {
    "use strict";
    let t, i, s;
    let l = {
        DESKTOP: "desktop",
        TABLET: "tablet",
        MOBILE: "mobile"
    }
      , r = {
        FEATURE_IMAGE_THUMBS: "feature_image_thumbs",
        FEATURE_IMAGE: "feature_image",
        PRODUCT_LIST: "product_list",
        CAROUSEL: "carousel"
    }
      , n = (e, t, i) => {
        var s, r, n, a, o, d;
        switch (t) {
        case l.TABLET:
            return null !== (r = null !== (s = null == e ? void 0 : e.tablet) && void 0 !== s ? s : null == e ? void 0 : e.desktop) && void 0 !== r ? r : i;
        case l.MOBILE:
            return null !== (o = null !== (a = null !== (n = null == e ? void 0 : e.mobile) && void 0 !== n ? n : null == e ? void 0 : e.tablet) && void 0 !== a ? a : null == e ? void 0 : e.desktop) && void 0 !== o ? o : i;
        default:
            return null !== (d = null == e ? void 0 : e.desktop) && void 0 !== d ? d : i
        }
    }
      , a = ["desktop", "tablet", "mobile"]
      , o = (e, t, i) => {
        let s = e.getAttribute("gp-data-interaction")
          , l = JSON.parse(s || "{}");
        e.setAttribute("gp-data-interaction", JSON.stringify({
            ...l,
            [t]: i
        }))
    }
      , d = e => {
        if (e)
            return e && "string" == typeof e && ((null == e ? void 0 : e.toLowerCase().startsWith("#")) || (null == e ? void 0 : e.toLowerCase().startsWith("rgb")) || (null == e ? void 0 : e.toLowerCase().startsWith("hsl")) || (null == e ? void 0 : e.toLowerCase().startsWith("transparent"))) ? e : `var(--g-c-${e}, ${e})`
    }
    ;
    function h(e) {
        return null !== e && "object" == typeof e && "constructor"in e && e.constructor === Object
    }
    function p(e, t) {
        void 0 === e && (e = {}),
        void 0 === t && (t = {});
        let i = ["__proto__", "constructor", "prototype"];
        Object.keys(t).filter(e => 0 > i.indexOf(e)).forEach(i => {
            void 0 === e[i] ? e[i] = t[i] : h(t[i]) && h(e[i]) && Object.keys(t[i]).length > 0 && p(e[i], t[i])
        }
        )
    }
    let u = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: {
            blur() {},
            nodeName: ""
        },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({
            initEvent() {}
        }),
        createElement: () => ({
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName: () => []
        }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        }
    };
    function c() {
        let e = "undefined" != typeof document ? document : {};
        return p(e, u),
        e
    }
    let v = {
        document: u,
        navigator: {
            userAgent: ""
        },
        location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: ""
        },
        history: {
            replaceState() {},
            pushState() {},
            go() {},
            back() {}
        },
        CustomEvent: function() {
            return this
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({
            getPropertyValue: () => ""
        }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: e => "undefined" == typeof setTimeout ? (e(),
        null) : setTimeout(e, 0),
        cancelAnimationFrame(e) {
            "undefined" != typeof setTimeout && clearTimeout(e)
        }
    };
    function m() {
        let e = "undefined" != typeof window ? window : {};
        return p(e, v),
        e
    }
    function g(e, t) {
        return void 0 === t && (t = 0),
        setTimeout(e, t)
    }
    function f() {
        return Date.now()
    }
    function w(e) {
        let t;
        let i = m();
        return i.getComputedStyle && (t = i.getComputedStyle(e, null)),
        !t && e.currentStyle && (t = e.currentStyle),
        t || (t = e.style),
        t
    }
    function S(e) {
        return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
    }
    function b() {
        let e = Object(arguments.length <= 0 ? void 0 : arguments[0])
          , t = ["__proto__", "constructor", "prototype"];
        for (let i = 1; i < arguments.length; i += 1) {
            let s = i < 0 || arguments.length <= i ? void 0 : arguments[i];
            if (null != s && ("undefined" != typeof window && void 0 !== window.HTMLElement ? !(s instanceof HTMLElement) : !s || 1 !== s.nodeType && 11 !== s.nodeType)) {
                let i = Object.keys(Object(s)).filter(e => 0 > t.indexOf(e));
                for (let t = 0, l = i.length; t < l; t += 1) {
                    let l = i[t]
                      , r = Object.getOwnPropertyDescriptor(s, l);
                    void 0 !== r && r.enumerable && (S(e[l]) && S(s[l]) ? s[l].__swiper__ ? e[l] = s[l] : b(e[l], s[l]) : !S(e[l]) && S(s[l]) ? (e[l] = {},
                    s[l].__swiper__ ? e[l] = s[l] : b(e[l], s[l])) : e[l] = s[l])
                }
            }
        }
        return e
    }
    function y(e, t, i) {
        e.style.setProperty(t, i)
    }
    function T(e) {
        let t, {swiper: i, targetPosition: s, side: l} = e, r = m(), n = -i.translate, a = null, o = i.params.speed;
        i.wrapperEl.style.scrollSnapType = "none",
        r.cancelAnimationFrame(i.cssModeFrameID);
        let d = s > n ? "next" : "prev"
          , h = (e, t) => "next" === d && e >= t || "prev" === d && e <= t
          , p = () => {
            t = new Date().getTime(),
            null === a && (a = t);
            let e = Math.max(Math.min((t - a) / o, 1), 0)
              , d = n + (.5 - Math.cos(e * Math.PI) / 2) * (s - n);
            if (h(d, s) && (d = s),
            i.wrapperEl.scrollTo({
                [l]: d
            }),
            h(d, s)) {
                i.wrapperEl.style.overflow = "hidden",
                i.wrapperEl.style.scrollSnapType = "",
                setTimeout( () => {
                    i.wrapperEl.style.overflow = "",
                    i.wrapperEl.scrollTo({
                        [l]: d
                    })
                }
                ),
                r.cancelAnimationFrame(i.cssModeFrameID);
                return
            }
            i.cssModeFrameID = r.requestAnimationFrame(p)
        }
        ;
        p()
    }
    function x(e, t) {
        void 0 === t && (t = "");
        let i = m()
          , s = [...e.children];
        return (i.HTMLSlotElement && e instanceof HTMLSlotElement && s.push(...e.assignedElements()),
        t) ? s.filter(e => e.matches(t)) : s
    }
    function E(e) {
        try {
            console.warn(e);
            return
        } catch (e) {}
    }
    function I(e, t) {
        var i;
        void 0 === t && (t = []);
        let s = document.createElement(e);
        return s.classList.add(...Array.isArray(t) ? t : (void 0 === (i = t) && (i = ""),
        i.trim().split(" ").filter(e => !!e.trim()))),
        s
    }
    function C(e, t) {
        let i = m();
        return i.getComputedStyle(e, null).getPropertyValue(t)
    }
    function k(e) {
        let t, i = e;
        if (i) {
            for (t = 0; null !== (i = i.previousSibling); )
                1 === i.nodeType && (t += 1);
            return t
        }
    }
    function P(e, t) {
        let i = []
          , s = e.parentElement;
        for (; s; )
            t ? s.matches(t) && i.push(s) : i.push(s),
            s = s.parentElement;
        return i
    }
    function M(e, t, i) {
        let s = m();
        return e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom"))
    }
    function L(e) {
        return (Array.isArray(e) ? e : [e]).filter(e => !!e)
    }
    function D(e, t) {
        void 0 === t && (t = ""),
        "undefined" != typeof trustedTypes ? e.innerHTML = trustedTypes.createPolicy("html", {
            createHTML: e => e
        }).createHTML(t) : e.innerHTML = t
    }
    function A(e) {
        let {styles: t, swiper: i, property: s} = e ?? {};
        return parseFloat(t.getPropertyValue(i.getDirectionLabel(s))) || 0
    }
    function O() {
        return t || (t = function() {
            let e = m()
              , t = c();
            return {
                smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior"in t.documentElement.style,
                touch: !!("ontouchstart"in e || e.DocumentTouch && t instanceof e.DocumentTouch)
            }
        }()),
        t
    }
    function z(e) {
        return void 0 === e && (e = {}),
        i || (i = function(e) {
            let {userAgent: t} = void 0 === e ? {} : e
              , i = O()
              , s = m()
              , l = s.navigator.platform
              , r = t || s.navigator.userAgent
              , n = {
                ios: !1,
                android: !1
            }
              , a = s.screen.width
              , o = s.screen.height
              , d = r.match(/(Android);?[\s\/]+([\d.]+)?/)
              , h = r.match(/(iPad).*OS\s([\d_]+)/)
              , p = r.match(/(iPod)(.*OS\s([\d_]+))?/)
              , u = !h && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/)
              , c = "MacIntel" === l;
            return !h && c && i.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${a}x${o}`) >= 0 && ((h = r.match(/(Version)\/([\d.]+)/)) || (h = [0, 1, "13_0_0"]),
            c = !1),
            d && "Win32" !== l && (n.os = "android",
            n.android = !0),
            (h || u || p) && (n.os = "ios",
            n.ios = !0),
            n
        }(e)),
        i
    }
    function B() {
        return s || (s = function() {
            let e = m()
              , t = z()
              , i = !1;
            function s() {
                let t = e.navigator.userAgent.toLowerCase();
                return t.indexOf("safari") >= 0 && 0 > t.indexOf("chrome") && 0 > t.indexOf("android")
            }
            if (s()) {
                let t = String(e.navigator.userAgent);
                if (t.includes("Version/")) {
                    let[e,s] = t.split("Version/")[1].split(" ")[0].split(".").map(e => Number(e));
                    i = e < 16 || 16 === e && s < 2
                }
            }
            let l = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
              , r = s()
              , n = r || l && t.ios;
            return {
                isSafari: i || r,
                needPerspectiveFix: i,
                need3dFix: n,
                isWebView: l
            }
        }()),
        s
    }
    let N = (e, t, i) => {
        t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i)
    }
      , G = (e, t, i) => {
        t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i)
    }
      , F = (e, t) => {
        if (!e || e.destroyed || !e.params)
            return;
        let i = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
        if (i) {
            let t = i.querySelector(`.${e.params.lazyPreloaderClass}`);
            !t && e.isElement && (i.shadowRoot ? t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame( () => {
                i.shadowRoot && (t = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`)) && t.remove()
            }
            )),
            t && t.remove()
        }
    }
      , _ = (e, t) => {
        if (!e.slides[t])
            return;
        let i = e.slides[t].querySelector('[loading="lazy"]');
        i && i.removeAttribute("loading")
    }
      , $ = e => {
        if (!e || e.destroyed || !e.params)
            return;
        let t = e.params.lazyPreloadPrevNext
          , i = e.slides.length;
        if (!i || !t || t < 0)
            return;
        t = Math.min(t, i);
        let s = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView)
          , l = e.activeIndex;
        if (e.params.grid && e.params.grid.rows > 1) {
            let i = [l - t];
            i.push(...Array.from({
                length: t
            }).map( (e, t) => l + s + t)),
            e.slides.forEach( (t, s) => {
                i.includes(t.column) && _(e, s)
            }
            );
            return
        }
        let r = l + s - 1;
        if (e.params.rewind || e.params.loop)
            for (let s = l - t; s <= r + t; s += 1) {
                let t = (s % i + i) % i;
                (t < l || t > r) && _(e, t)
            }
        else
            for (let s = Math.max(l - t, 0); s <= Math.min(r + t, i - 1); s += 1)
                s !== l && (s > r || s < l) && _(e, s)
    }
    ;
    function V(e) {
        let {swiper: t, runCallbacks: i, direction: s, step: l} = e
          , {activeIndex: r, previousIndex: n} = t
          , a = s;
        a || (a = r > n ? "next" : r < n ? "prev" : "reset"),
        t.emit(`transition${l}`),
        i && "reset" === a ? t.emit(`slideResetTransition${l}`) : i && r !== n && (t.emit(`slideChangeTransition${l}`),
        "next" === a ? t.emit(`slideNextTransition${l}`) : t.emit(`slidePrevTransition${l}`))
    }
    function R(e, t, i) {
        let s = m()
          , {params: l} = e
          , r = l.edgeSwipeDetection
          , n = l.edgeSwipeThreshold;
        return !r || !(i <= n) && !(i >= s.innerWidth - n) || "prevent" === r && (t.preventDefault(),
        !0)
    }
    function H(e) {
        let t = c()
          , i = e;
        i.originalEvent && (i = i.originalEvent);
        let s = this.touchEventsData;
        if ("pointerdown" === i.type) {
            if (null !== s.pointerId && s.pointerId !== i.pointerId)
                return;
            s.pointerId = i.pointerId
        } else
            "touchstart" === i.type && 1 === i.targetTouches.length && (s.touchId = i.targetTouches[0].identifier);
        if ("touchstart" === i.type) {
            R(this, i, i.targetTouches[0].pageX);
            return
        }
        let {params: l, touches: r, enabled: n} = this;
        if (!n || !l.simulateTouch && "mouse" === i.pointerType || this.animating && l.preventInteractionOnTransition)
            return;
        !this.animating && l.cssMode && l.loop && this.loopFix();
        let a = i.target;
        if ("wrapper" === l.touchEventsTarget && !function(e, t) {
            let i = m()
              , s = t.contains(e);
            if (!s && i.HTMLSlotElement && t instanceof HTMLSlotElement) {
                let i = [...t.assignedElements()];
                (s = i.includes(e)) || (s = function(e, t) {
                    let i = [t];
                    for (; i.length > 0; ) {
                        let t = i.shift();
                        if (e === t)
                            return !0;
                        i.push(...t.children, ...t.shadowRoot ? t.shadowRoot.children : [], ...t.assignedElements ? t.assignedElements() : [])
                    }
                }(e, t))
            }
            return s
        }(a, this.wrapperEl) || "which"in i && 3 === i.which || "button"in i && i.button > 0 || s.isTouched && s.isMoved)
            return;
        let o = !!l.noSwipingClass && "" !== l.noSwipingClass
          , d = i.composedPath ? i.composedPath() : i.path;
        o && i.target && i.target.shadowRoot && d && (a = d[0]);
        let h = l.noSwipingSelector ? l.noSwipingSelector : `.${l.noSwipingClass}`
          , p = !!(i.target && i.target.shadowRoot);
        if (l.noSwiping && (p ? function(e, t) {
            return void 0 === t && (t = this),
            function t(i) {
                if (!i || i === c() || i === m())
                    return null;
                i.assignedSlot && (i = i.assignedSlot);
                let s = i.closest(e);
                return s || i.getRootNode ? s || t(i.getRootNode().host) : null
            }(t)
        }(h, a) : a.closest(h))) {
            this.allowClick = !0;
            return
        }
        if (l.swipeHandler && !a.closest(l.swipeHandler))
            return;
        r.currentX = i.pageX,
        r.currentY = i.pageY;
        let u = r.currentX
          , v = r.currentY;
        if (!R(this, i, u))
            return;
        Object.assign(s, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0
        }),
        r.startX = u,
        r.startY = v,
        s.touchStartTime = f(),
        this.allowClick = !0,
        this.updateSize(),
        this.swipeDirection = void 0,
        l.threshold > 0 && (s.allowThresholdMove = !1);
        let g = !0;
        a.matches(s.focusableElements) && (g = !1,
        "SELECT" === a.nodeName && (s.isTouched = !1)),
        t.activeElement && t.activeElement.matches(s.focusableElements) && t.activeElement !== a && ("mouse" === i.pointerType || "mouse" !== i.pointerType && !a.matches(s.focusableElements)) && t.activeElement.blur();
        let w = g && this.allowTouchMove && l.touchStartPreventDefault;
        (l.touchStartForcePreventDefault || w) && !a.isContentEditable && i.preventDefault(),
        this.emit("touchStart", i)
    }
    function W(e) {
        let t;
        let i = c()
          , s = this.touchEventsData
          , {params: l, touches: r, rtlTranslate: n, enabled: a} = this;
        if (!a || !l.simulateTouch && "mouse" === e.pointerType)
            return;
        let o = e;
        if (o.originalEvent && (o = o.originalEvent),
        "pointermove" === o.type) {
            if (null !== s.touchId)
                return;
            let e = o.pointerId;
            if (e !== s.pointerId)
                return
        }
        if ("touchmove" === o.type) {
            if (!(t = [...o.changedTouches].find(e => e.identifier === s.touchId)) || t.identifier !== s.touchId)
                return
        } else
            t = o;
        if (!s.isTouched) {
            s.startMoving && s.isScrolling && this.emit("touchMoveOpposite", o);
            return
        }
        let d = t.pageX
          , h = t.pageY;
        if (o.preventedByNestedSwiper) {
            r.startX = d,
            r.startY = h;
            return
        }
        if (!this.allowTouchMove) {
            o.target.matches(s.focusableElements) || (this.allowClick = !1),
            s.isTouched && (Object.assign(r, {
                startX: d,
                startY: h,
                currentX: d,
                currentY: h
            }),
            s.touchStartTime = f());
            return
        }
        if (l.touchReleaseOnEdges && !l.loop) {
            if (this.isVertical()) {
                if (h < r.startY && this.translate <= this.maxTranslate() || h > r.startY && this.translate >= this.minTranslate()) {
                    s.isTouched = !1,
                    s.isMoved = !1;
                    return
                }
            } else if (n && (d > r.startX && -this.translate <= this.maxTranslate() || d < r.startX && -this.translate >= this.minTranslate()))
                return;
            else if (!n && (d < r.startX && this.translate <= this.maxTranslate() || d > r.startX && this.translate >= this.minTranslate()))
                return
        }
        if (i.activeElement && i.activeElement.matches(s.focusableElements) && i.activeElement !== o.target && "mouse" !== o.pointerType && i.activeElement.blur(),
        i.activeElement && o.target === i.activeElement && o.target.matches(s.focusableElements)) {
            s.isMoved = !0,
            this.allowClick = !1;
            return
        }
        s.allowTouchCallbacks && this.emit("touchMove", o),
        r.previousX = r.currentX,
        r.previousY = r.currentY,
        r.currentX = d,
        r.currentY = h;
        let p = r.currentX - r.startX
          , u = r.currentY - r.startY;
        if (this.params.threshold && Math.sqrt(p ** 2 + u ** 2) < this.params.threshold)
            return;
        if (void 0 === s.isScrolling) {
            let e;
            this.isHorizontal() && r.currentY === r.startY || this.isVertical() && r.currentX === r.startX ? s.isScrolling = !1 : p * p + u * u >= 25 && (e = 180 * Math.atan2(Math.abs(u), Math.abs(p)) / Math.PI,
            s.isScrolling = this.isHorizontal() ? e > l.touchAngle : 90 - e > l.touchAngle)
        }
        if (s.isScrolling && this.emit("touchMoveOpposite", o),
        void 0 === s.startMoving && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0),
        s.isScrolling || "touchmove" === o.type && s.preventTouchMoveFromPointerMove) {
            s.isTouched = !1;
            return
        }
        if (!s.startMoving)
            return;
        this.allowClick = !1,
        !l.cssMode && o.cancelable && o.preventDefault(),
        l.touchMoveStopPropagation && !l.nested && o.stopPropagation();
        let v = this.isHorizontal() ? p : u
          , m = this.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
        l.oneWayMovement && (v = Math.abs(v) * (n ? 1 : -1),
        m = Math.abs(m) * (n ? 1 : -1)),
        r.diff = v,
        v *= l.touchRatio,
        n && (v = -v,
        m = -m);
        let g = this.touchesDirection;
        this.swipeDirection = v > 0 ? "prev" : "next",
        this.touchesDirection = m > 0 ? "prev" : "next";
        let w = this.params.loop && !l.cssMode
          , S = "next" === this.touchesDirection && this.allowSlideNext || "prev" === this.touchesDirection && this.allowSlidePrev;
        if (!s.isMoved) {
            if (w && S && this.loopFix({
                direction: this.swipeDirection
            }),
            s.startTranslate = this.getTranslate(),
            this.setTransition(0),
            this.animating) {
                let e = new window.CustomEvent("transitionend",{
                    bubbles: !0,
                    cancelable: !0,
                    detail: {
                        bySwiperTouchMove: !0
                    }
                });
                this.wrapperEl.dispatchEvent(e)
            }
            s.allowMomentumBounce = !1,
            l.grabCursor && (!0 === this.allowSlideNext || !0 === this.allowSlidePrev) && this.setGrabCursor(!0),
            this.emit("sliderFirstMove", o)
        }
        if (!1 !== l._loopSwapReset && s.isMoved && s.allowThresholdMove && g !== this.touchesDirection && w && S && Math.abs(v) >= 1) {
            Object.assign(r, {
                startX: d,
                startY: h,
                currentX: d,
                currentY: h,
                startTranslate: s.currentTranslate
            }),
            s.loopSwapReset = !0,
            s.startTranslate = s.currentTranslate;
            return
        }
        this.emit("sliderMove", o),
        s.isMoved = !0,
        s.currentTranslate = v + s.startTranslate;
        let b = !0
          , y = l.resistanceRatio;
        if (l.touchReleaseOnEdges && (y = 0),
        v > 0 ? (w && S && s.allowThresholdMove && s.currentTranslate > (l.centeredSlides ? this.minTranslate() - this.slidesSizesGrid[this.activeIndex + 1] - ("auto" !== l.slidesPerView && this.slides.length - l.slidesPerView >= 2 ? this.slidesSizesGrid[this.activeIndex + 1] + this.params.spaceBetween : 0) - this.params.spaceBetween : this.minTranslate()) && this.loopFix({
            direction: "prev",
            setTranslate: !0,
            activeSlideIndex: 0
        }),
        s.currentTranslate > this.minTranslate() && (b = !1,
        l.resistance && (s.currentTranslate = this.minTranslate() - 1 + (-this.minTranslate() + s.startTranslate + v) ** y))) : v < 0 && (w && S && s.allowThresholdMove && s.currentTranslate < (l.centeredSlides ? this.maxTranslate() + this.slidesSizesGrid[this.slidesSizesGrid.length - 1] + this.params.spaceBetween + ("auto" !== l.slidesPerView && this.slides.length - l.slidesPerView >= 2 ? this.slidesSizesGrid[this.slidesSizesGrid.length - 1] + this.params.spaceBetween : 0) : this.maxTranslate()) && this.loopFix({
            direction: "next",
            setTranslate: !0,
            activeSlideIndex: this.slides.length - ("auto" === l.slidesPerView ? this.slidesPerViewDynamic() : Math.ceil(parseFloat(l.slidesPerView, 10)))
        }),
        s.currentTranslate < this.maxTranslate() && (b = !1,
        l.resistance && (s.currentTranslate = this.maxTranslate() + 1 - (this.maxTranslate() - s.startTranslate - v) ** y))),
        b && (o.preventedByNestedSwiper = !0),
        !this.allowSlideNext && "next" === this.swipeDirection && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate),
        !this.allowSlidePrev && "prev" === this.swipeDirection && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate),
        this.allowSlidePrev || this.allowSlideNext || (s.currentTranslate = s.startTranslate),
        l.threshold > 0) {
            if (Math.abs(v) > l.threshold || s.allowThresholdMove) {
                if (!s.allowThresholdMove) {
                    s.allowThresholdMove = !0,
                    r.startX = r.currentX,
                    r.startY = r.currentY,
                    s.currentTranslate = s.startTranslate,
                    r.diff = this.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
                    return
                }
            } else {
                s.currentTranslate = s.startTranslate;
                return
            }
        }
        l.followFinger && !l.cssMode && (l.watchSlidesProgress && (this.updateActiveIndex(),
        this.updateSlidesClasses()),
        this.updateProgress(s.currentTranslate),
        this.setTranslate(s.currentTranslate))
    }
    function q(e) {
        let t, i;
        let s = this
          , l = s.touchEventsData
          , r = e;
        r.originalEvent && (r = r.originalEvent);
        let n = "touchend" === r.type || "touchcancel" === r.type;
        if (n) {
            if (!(t = [...r.changedTouches].find(e => e.identifier === l.touchId)) || t.identifier !== l.touchId)
                return
        } else {
            if (null !== l.touchId || r.pointerId !== l.pointerId)
                return;
            t = r
        }
        if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(r.type)) {
            let e = ["pointercancel", "contextmenu"].includes(r.type) && (s.browser.isSafari || s.browser.isWebView);
            if (!e)
                return
        }
        l.pointerId = null,
        l.touchId = null;
        let {params: a, touches: o, rtlTranslate: d, slidesGrid: h, enabled: p} = s;
        if (!p || !a.simulateTouch && "mouse" === r.pointerType)
            return;
        if (l.allowTouchCallbacks && s.emit("touchEnd", r),
        l.allowTouchCallbacks = !1,
        !l.isTouched) {
            l.isMoved && a.grabCursor && s.setGrabCursor(!1),
            l.isMoved = !1,
            l.startMoving = !1;
            return
        }
        a.grabCursor && l.isMoved && l.isTouched && (!0 === s.allowSlideNext || !0 === s.allowSlidePrev) && s.setGrabCursor(!1);
        let u = f()
          , c = u - l.touchStartTime;
        if (s.allowClick) {
            let e = r.path || r.composedPath && r.composedPath();
            s.updateClickedSlide(e && e[0] || r.target, e),
            s.emit("tap click", r),
            c < 300 && u - l.lastClickTime < 300 && s.emit("doubleTap doubleClick", r)
        }
        if (l.lastClickTime = f(),
        g( () => {
            s.destroyed || (s.allowClick = !0)
        }
        ),
        !l.isTouched || !l.isMoved || !s.swipeDirection || 0 === o.diff && !l.loopSwapReset || l.currentTranslate === l.startTranslate && !l.loopSwapReset) {
            l.isTouched = !1,
            l.isMoved = !1,
            l.startMoving = !1;
            return
        }
        if (l.isTouched = !1,
        l.isMoved = !1,
        l.startMoving = !1,
        i = a.followFinger ? d ? s.translate : -s.translate : -l.currentTranslate,
        a.cssMode)
            return;
        let v = s.maxTranslate()
          , m = i >= -v && !s.params.loop
          , w = h.length - 1;
        if (a.centeredSlides && a.isSneakPeekCenter) {
            let e = a.slidesPerView;
            e = Math.max(e = "auto" === e ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(a.slidesPerView, 10)), 1),
            w = Math.max(h.length - e, 0)
        }
        let S = 0
          , b = s.slidesSizesGrid[0];
        for (let e = 0; e < h.length; e += e < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
            let t = e < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
            void 0 !== h[e + t] ? (m || i >= h[e] && i < h[e + t]) && (S = e,
            b = h[e + t] - h[e]) : (m || i >= h[e]) && (S = e,
            b = h[h.length - 1] - h[h.length - 2])
        }
        if (m && S > w) {
            S = w;
            let e = Math.min(w + 1, h.length - 1);
            b = h[e] - h[w] || b
        }
        let y = null
          , T = null;
        a.rewind && (s.isBeginning ? T = s.slides.length - 1 : s.isEnd && (y = 0));
        let x = (i - h[S]) / b
          , E = S < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
        if (c > a.longSwipesMs) {
            if (!a.longSwipes) {
                s.slideTo(s.activeIndex);
                return
            }
            "next" === s.swipeDirection && (x >= a.longSwipesRatio ? s.slideTo(a.rewind && s.isEnd ? y : S + E) : s.slideTo(S)),
            "prev" === s.swipeDirection && (x > 1 - a.longSwipesRatio ? s.slideTo(S + E) : null !== T && x < 0 && Math.abs(x) > a.longSwipesRatio ? s.slideTo(T) : s.slideTo(S))
        } else {
            if (!a.shortSwipes) {
                s.slideTo(s.activeIndex);
                return
            }
            let e = s.navigation && (r.target === s.navigation.nextEl || r.target === s.navigation.prevEl);
            e ? r.target === s.navigation.nextEl ? s.slideTo(S + E) : s.slideTo(S) : ("next" === s.swipeDirection && s.slideTo(null !== y ? y : S + E),
            "prev" === s.swipeDirection && s.slideTo(null !== T ? T : S))
        }
    }
    function j() {
        let e = this
          , {params: t, el: i} = e;
        if (i && 0 === i.offsetWidth)
            return;
        t.breakpoints && e.setBreakpoint();
        let {allowSlideNext: s, allowSlidePrev: l, snapGrid: r} = e;
        e.allowSlideNext = !0,
        e.allowSlidePrev = !0,
        e.updateSize(),
        e.updateSlides(),
        e.updateSlidesClasses(),
        ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0),
        e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout),
        e.autoplay.resizeTimeout = setTimeout( () => {
            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
        }
        , 500)),
        e.allowSlidePrev = l,
        e.allowSlideNext = s,
        t.watchOverflow && r !== e.snapGrid && e.checkOverflow()
    }
    function X(e) {
        this.enabled && !this.allowClick && (this.params.preventClicks && e.preventDefault(),
        this.params.preventClicksPropagation && this.animating && (e.stopPropagation(),
        e.stopImmediatePropagation()))
    }
    function Y() {
        let {wrapperEl: e, rtlTranslate: t, enabled: i} = this;
        if (!i)
            return;
        this.previousTranslate = this.translate,
        this.isHorizontal() ? this.translate = -e.scrollLeft : this.translate = -e.scrollTop,
        0 === this.translate && (this.translate = 0),
        this.updateActiveIndex(),
        this.updateSlidesClasses();
        let s = this.maxTranslate() - this.minTranslate();
        (0 === s ? 0 : (this.translate - this.minTranslate()) / s) !== this.progress && this.updateProgress(t ? -this.translate : this.translate),
        this.emit("setTranslate", this.translate, !1)
    }
    function U(e) {
        if (F(this, e.target),
        this.params.cssMode || "auto" !== this.params.slidesPerView && !this.params.autoHeight)
            return;
        let t = e?.target;
        t && ["IMG", "IFRAME", "EMBED"].includes(t.tagName) && (t.hasAttribute("width") && t.hasAttribute("height") || this.update())
    }
    function K() {
        !this.documentTouchHandlerProceeded && (this.documentTouchHandlerProceeded = !0,
        this.params.touchReleaseOnEdges && (this.el.style.touchAction = "auto"))
    }
    let Q = (e, t) => {
        let i = c()
          , {params: s, el: l, wrapperEl: r, device: n} = e
          , a = !!s.nested
          , o = "on" === t ? "addEventListener" : "removeEventListener";
        l && "string" != typeof l && (i[o]("touchstart", e.onDocumentTouchStart, {
            passive: !1,
            capture: a
        }),
        l[o]("touchstart", e.onTouchStart, {
            passive: !1
        }),
        l[o]("pointerdown", e.onTouchStart, {
            passive: !1
        }),
        i[o]("touchmove", e.onTouchMove, {
            passive: !1,
            capture: a
        }),
        i[o]("pointermove", e.onTouchMove, {
            passive: !1,
            capture: a
        }),
        i[o]("touchend", e.onTouchEnd, {
            passive: !0
        }),
        i[o]("pointerup", e.onTouchEnd, {
            passive: !0
        }),
        i[o]("pointercancel", e.onTouchEnd, {
            passive: !0
        }),
        i[o]("touchcancel", e.onTouchEnd, {
            passive: !0
        }),
        i[o]("pointerout", e.onTouchEnd, {
            passive: !0
        }),
        i[o]("pointerleave", e.onTouchEnd, {
            passive: !0
        }),
        i[o]("contextmenu", e.onTouchEnd, {
            passive: !0
        }),
        (s.preventClicks || s.preventClicksPropagation) && l[o]("click", e.onClick, !0),
        s.cssMode && r[o]("scroll", e.onScroll),
        s.updateOnWindowResize ? e[t](n.ios || n.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", j, !0) : e[t]("observerUpdate", j, !0),
        l[o]("load", e.onLoad, {
            capture: !0
        }))
    }
      , J = (e, t, i, s) => {
        let l = t[s] && t[s].enabled
          , r = i[s] && i[s].enabled;
        l && !r && e[s].disable(),
        !l && r && e[s].enable()
    }
    ;
    class Z {
        constructor() {
            if (Z.instance)
                return Z.instance;
            this.debounceResize = this.debounceResize.bind(this),
            this.orientationChangeHandler = this.orientationChangeHandler.bind(this),
            this.updateScreenSize();
            let e = m();
            e.addEventListener("resize", this.debounceResize),
            e.addEventListener("orientationchange", this.orientationChangeHandler)
        }
        updateScreenSize() {
            let e = m();
            this._width = e.innerWidth,
            this._height = e.innerHeight
        }
        getWindowSize() {
            return {
                width: this._width,
                height: this._height
            }
        }
        orientationChangeHandler() {
            this.updateScreenSize()
        }
        debounceResize() {
            this.resizeTimeout && clearTimeout(this.resizeTimeout),
            this.resizeTimeout = setTimeout( () => {
                this.updateScreenSize()
            }
            , 50)
        }
        destroy() {
            this.resizeTimeout && clearTimeout(this.resizeTimeout);
            let e = m();
            e.removeEventListener("resize", this.debounceResize),
            e.removeEventListener("orientationchange", this.orientationChangeHandler),
            Z.instance = null
        }
    }
    Z.instance = null,
    Z.getScreenSizeObject = () => window.screenSize ? window.screenSize : (Z.instance || (Z.instance = new Z),
    Z.instance);
    let ee = (e, t) => {
        let i = [];
        return e.forEach(e => {
            "object" == typeof e ? Object.keys(e).forEach(s => {
                e[s] && i.push(t + s)
            }
            ) : "string" == typeof e && i.push(t + e)
        }
        ),
        i
    }
    ;
    var et = {
        init: !0,
        direction: "horizontal",
        oneWayMovement: !1,
        swiperElementNodeName: "SWIPER-CONTAINER",
        touchEventsTarget: "wrapper",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        eventsPrefix: "swiper",
        enabled: !0,
        focusableElements: "input, select, option, textarea, button, video, label",
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 5,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        loop: !1,
        loopAddBlankSlides: !0,
        loopAdditionalSlides: 0,
        loopPreventsSliding: !0,
        isSneakPeekCenter: !1,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        maxBackfaceHiddenSlides: 10,
        containerModifierClass: "swiper-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-blank",
        slideActiveClass: "swiper-slide-active",
        slideVisibleClass: "swiper-slide-visible",
        slideFullyVisibleClass: "swiper-slide-fully-visible",
        slideNextClass: "swiper-slide-next",
        slidePrevClass: "swiper-slide-prev",
        wrapperClass: "swiper-wrapper",
        lazyPreloaderClass: "swiper-lazy-preloader",
        lazyPreloadPrevNext: 0,
        runCallbacksOnInit: !0,
        _emitClasses: !1
    };
    let ei = {
        eventsEmitter: {
            on(e, t, i) {
                let s = this;
                if (!s.eventsListeners || s.destroyed || "function" != typeof t)
                    return s;
                let l = i ? "unshift" : "push";
                return e.split(" ").forEach(e => {
                    s.eventsListeners[e] || (s.eventsListeners[e] = []),
                    s.eventsListeners[e][l](t)
                }
                ),
                s
            },
            once(e, t, i) {
                let s = this;
                if (!s.eventsListeners || s.destroyed || "function" != typeof t)
                    return s;
                function l() {
                    s.off(e, l),
                    l.__emitterProxy && delete l.__emitterProxy;
                    for (var i = arguments.length, r = Array(i), n = 0; n < i; n++)
                        r[n] = arguments[n];
                    t.apply(s, r)
                }
                return l.__emitterProxy = t,
                s.on(e, l, i)
            },
            onAny(e, t) {
                return !this.eventsListeners || this.destroyed || "function" != typeof e || 0 > this.eventsAnyListeners.indexOf(e) && this.eventsAnyListeners[t ? "unshift" : "push"](e),
                this
            },
            offAny(e) {
                if (!this.eventsListeners || this.destroyed || !this.eventsAnyListeners)
                    return this;
                let t = this.eventsAnyListeners.indexOf(e);
                return t >= 0 && this.eventsAnyListeners.splice(t, 1),
                this
            },
            off(e, t) {
                let i = this;
                return i.eventsListeners && !i.destroyed && i.eventsListeners && e.split(" ").forEach(e => {
                    void 0 === t ? i.eventsListeners[e] = [] : i.eventsListeners[e] && i.eventsListeners[e].forEach( (s, l) => {
                        (s === t || s.__emitterProxy && s.__emitterProxy === t) && i.eventsListeners[e].splice(l, 1)
                    }
                    )
                }
                ),
                i
            },
            emit() {
                let e, t, i;
                let s = this;
                if (!s.eventsListeners || s.destroyed || !s.eventsListeners)
                    return s;
                for (var l = arguments.length, r = Array(l), n = 0; n < l; n++)
                    r[n] = arguments[n];
                "string" == typeof r[0] || Array.isArray(r[0]) ? (e = r[0],
                t = r.slice(1, r.length),
                i = s) : (e = r[0].events,
                t = r[0].data,
                i = r[0].context || s),
                t.unshift(i);
                let a = Array.isArray(e) ? e : e.split(" ");
                return a.forEach(e => {
                    s.eventsAnyListeners && s.eventsAnyListeners.length && s.eventsAnyListeners.forEach(s => {
                        s.apply(i, [e, ...t])
                    }
                    ),
                    s.eventsListeners && s.eventsListeners[e] && s.eventsListeners[e].forEach(e => {
                        e.apply(i, t)
                    }
                    )
                }
                ),
                s
            }
        },
        update: {
            updateSize: function() {
                let e, t;
                let i = this.el;
                e = void 0 !== this.params.width && null !== this.params.width ? this.params.width : i.clientWidth,
                t = void 0 !== this.params.height && null !== this.params.height ? this.params.height : i.clientHeight,
                0 === e && this.isHorizontal() || 0 === t && this.isVertical() || (e = e - parseInt(C(i, "padding-left") || 0, 10) - parseInt(C(i, "padding-right") || 0, 10),
                t = t - parseInt(C(i, "padding-top") || 0, 10) - parseInt(C(i, "padding-bottom") || 0, 10),
                Number.isNaN(e) && (e = 0),
                Number.isNaN(t) && (t = 0),
                Object.assign(this, {
                    width: e,
                    height: t,
                    size: this.isHorizontal() ? e : t
                }))
            },
            updateSlides: function() {
                let e;
                let t = this.params
                  , {wrapperEl: i, slidesEl: s, size: l, rtlTranslate: r} = this
                  , n = x(s, `.${this.params.slideClass}, swiper-slide`)
                  , a = n.length
                  , o = []
                  , d = []
                  , h = []
                  , p = t.slidesOffsetBefore;
                "function" == typeof p && (p = t.slidesOffsetBefore.call(this));
                let u = t.slidesOffsetAfter;
                "function" == typeof u && (u = t.slidesOffsetAfter.call(this));
                let c = this.snapGrid.length
                  , v = this.slidesGrid.length
                  , m = t.spaceBetween
                  , g = -p
                  , f = 0
                  , S = 0;
                if (void 0 === l)
                    return;
                "string" == typeof m && m.indexOf("%") >= 0 ? m = parseFloat(m.replace("%", "")) / 100 * l : "string" == typeof m && (m = parseFloat(m)),
                this.slidesTotalSize = -m,
                n.forEach(e => {
                    r ? e.style.marginLeft = "" : e.style.marginRight = "",
                    e.style.marginBottom = "",
                    e.style.marginTop = ""
                }
                ),
                t.centeredSlides && t.cssMode && (y(i, "--swiper-centered-offset-before", ""),
                y(i, "--swiper-centered-offset-after", ""));
                let b = "auto" === t.slidesPerView && t.breakpoints && Object.keys(t.breakpoints).filter(e => void 0 !== t.breakpoints[e].slidesPerView).length > 0
                  , T = "auto" === t.slidesPerView
                  , E = [];
                if (T)
                    for (let e = 0; e < a; e += 1) {
                        if (!n[e])
                            continue;
                        b && (n[e].style[this.getDirectionLabel("width")] = "");
                        let t = n[e].style.transform
                          , i = n[e].style.webkitTransform;
                        E[e] = {
                            transform: t,
                            webkitTransform: i
                        },
                        t && (n[e].style.transform = "none"),
                        i && (n[e].style.webkitTransform = "none")
                    }
                let I = this.isElement ? this.wrapperEl[`offset${this.isHorizontal() ? "Left" : "Top"}`] : 0
                  , k = []
                  , P = [];
                for (let e = 0; e < a; e += 1) {
                    if (!n[e] || "none" === C(n[e], "display")) {
                        k[e] = !1;
                        continue
                    }
                    k[e] = !0,
                    T && (t.roundLengths ? P[e] = this.isHorizontal() ? M(n[e], "width") : M(n[e], "height") : P[e] = function(e) {
                        let {el: t, swiper: i} = e ?? {}
                          , s = w(t)
                          , l = A({
                            styles: s,
                            swiper: i,
                            property: "width"
                        })
                          , r = A({
                            styles: s,
                            swiper: i,
                            property: "padding-left"
                        })
                          , n = A({
                            styles: s,
                            swiper: i,
                            property: "padding-right"
                        })
                          , a = A({
                            styles: s,
                            swiper: i,
                            property: "margin-left"
                        })
                          , o = A({
                            styles: s,
                            swiper: i,
                            property: "margin-right"
                        })
                          , d = s.getPropertyValue("box-sizing");
                        if (d && "border-box" === d)
                            return l + a + o;
                        let {clientWidth: h, offsetWidth: p} = t;
                        return l + r + n + a + o + (p - h)
                    }({
                        el: n[e],
                        swiper: this
                    }),
                    t.roundLengths && (P[e] = Math.floor(P[e])))
                }
                if (T)
                    for (let e = 0; e < a; e += 1)
                        E[e] && (E[e].transform && (n[e].style.transform = E[e].transform),
                        E[e].webkitTransform && (n[e].style.webkitTransform = E[e].webkitTransform));
                let L = this.cssOverflowAdjustment();
                for (let i = 0; i < a; i += 1)
                    e = 0,
                    k[i] && (T ? e = P[i] || 0 : (e = (l - (t.slidesPerView - 1) * m) / t.slidesPerView,
                    t.roundLengths && (e = Math.floor(e)),
                    n[i] && (n[i].style[this.getDirectionLabel("width")] = `${e}px`)),
                    n[i] && (n[i].swiperSlideSize = e),
                    h.push(e),
                    t.centeredSlides ? (g = g + e / 2 + f / 2 + m,
                    0 === f && 0 !== i && (g = g - l / 2 - m),
                    0 === i && (g = g - l / 2 - m),
                    .001 > Math.abs(g) && (g = 0),
                    t.roundLengths && (g = Math.floor(g)),
                    S % t.slidesPerGroup == 0 && o.push(g),
                    d.push(g)) : (t.roundLengths && (g = Math.floor(g)),
                    (S - Math.min(this.params.slidesPerGroupSkip, S)) % this.params.slidesPerGroup == 0 && o.push(g),
                    d.push(g),
                    g = g + e + m),
                    n[i] && (n[i].swiperSlideOffset = d[d.length - 1] - L - I),
                    this.slidesTotalSize += e + m,
                    f = e,
                    S += 1);
                if (this.slidesTotalSize = Math.max(this.slidesTotalSize, l) + u,
                t.setWrapperSize && (i.style[this.getDirectionLabel("width")] = `${this.slidesTotalSize + m}px`),
                !t.centeredSlides) {
                    let e = [];
                    for (let i = 0; i < o.length; i += 1) {
                        let s = o[i];
                        t.roundLengths && (s = Math.floor(s)),
                        o[i] <= this.slidesTotalSize - l && e.push(s)
                    }
                    o = e,
                    Math.floor(this.slidesTotalSize - l) - Math.floor(o[o.length - 1]) > 1 && o.push(this.slidesTotalSize - l)
                }
                if (0 === o.length && (o = [0]),
                0 !== m) {
                    let e = this.isHorizontal() && r ? "marginLeft" : this.getDirectionLabel("marginRight");
                    n.filter( (e, i) => !t.cssMode || !!t.loop || i !== n.length - 1).forEach(t => {
                        t.style[e] = `${m}px`
                    }
                    )
                }
                if (t.centeredSlides && t.centeredSlidesBounds) {
                    let e = 0;
                    h.forEach(t => {
                        e += t + (m || 0)
                    }
                    ),
                    e -= m;
                    let t = e > l ? e - l : 0;
                    o = o.map(e => e <= 0 ? -p : e > t ? t + u : e)
                }
                if (t.centerInsufficientSlides) {
                    let e = 0;
                    h.forEach(t => {
                        e += t + (m || 0)
                    }
                    ),
                    e -= m;
                    let i = (t.slidesOffsetBefore || 0) + (t.slidesOffsetAfter || 0);
                    if (e + i < l) {
                        let t = (l - e - i) / 2;
                        o.forEach( (e, i) => {
                            o[i] = e - t
                        }
                        ),
                        d.forEach( (e, i) => {
                            d[i] = e + t
                        }
                        )
                    }
                }
                if (Object.assign(this, {
                    slides: n,
                    snapGrid: o,
                    slidesGrid: d,
                    slidesSizesGrid: h
                }),
                t.centeredSlides && t.cssMode && !t.centeredSlidesBounds) {
                    y(i, "--swiper-centered-offset-before", `${-o[0]}px`),
                    y(i, "--swiper-centered-offset-after", `${this.size / 2 - h[h.length - 1] / 2}px`);
                    let e = -this.snapGrid[0]
                      , t = -this.slidesGrid[0];
                    this.snapGrid = this.snapGrid.map(t => t + e),
                    this.slidesGrid = this.slidesGrid.map(e => e + t)
                }
                if (a !== n.length && this.emit("slidesLengthChange"),
                o.length !== c && (this.params.watchOverflow && this.checkOverflow(),
                this.emit("snapGridLengthChange")),
                d.length !== v && this.emit("slidesGridLengthChange"),
                t.watchSlidesProgress && this.updateSlidesOffset({
                    isCalculatedFromUpdateSlides: !0
                }),
                this.emit("slidesUpdated"),
                !t.cssMode && "slide" === t.effect) {
                    let e = `${t.containerModifierClass}backface-hidden`
                      , i = this.el.classList.contains(e);
                    a <= t.maxBackfaceHiddenSlides ? i || this.el.classList.add(e) : i && this.el.classList.remove(e)
                }
            },
            updateAutoHeight: function(e) {
                let t = this
                  , i = [];
                "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                let s = e => t.slides[e];
                if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1) {
                    if (t.params.centeredSlides)
                        (t.visibleSlides || []).forEach(e => {
                            i.push(e)
                        }
                        );
                    else
                        for (let e = 0; e < Math.ceil(t.params.slidesPerView); e += 1) {
                            let l = t.activeIndex + e;
                            if (l > t.slides.length)
                                break;
                            i.push(s(l))
                        }
                } else
                    i.push(s(t.activeIndex));
                let l = 0;
                for (let e = 0; e < i.length; e += 1)
                    if (void 0 !== i[e]) {
                        let t = i[e].offsetHeight;
                        l = t > l ? t : l
                    }
                (l || 0 === l) && (t.wrapperEl.style.height = `${l}px`)
            },
            updateSlidesOffset: function(e) {
                let {isCalculatedFromUpdateSlides: t=!1} = e ?? {};
                if (t)
                    return;
                let i = this.slides
                  , s = this.isElement ? this.isHorizontal() ? this.wrapperEl.offsetLeft : this.wrapperEl.offsetTop : 0;
                for (let e = 0; e < i.length; e += 1)
                    i[e].swiperSlideOffset = (this.isHorizontal() ? i[e].offsetLeft : i[e].offsetTop) - s - this.cssOverflowAdjustment()
            },
            updateSlidesProgress: function(e) {
                void 0 === e && (e = this && this.translate || 0);
                let t = this.params
                  , {slides: i, rtlTranslate: s, snapGrid: l} = this;
                if (0 === i.length)
                    return;
                void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
                let r = -e;
                s && (r = e),
                this.visibleSlidesIndexes = [],
                this.visibleSlides = [];
                let n = t.spaceBetween;
                "string" == typeof n && n.indexOf("%") >= 0 ? n = parseFloat(n.replace("%", "")) / 100 * this.size : "string" == typeof n && (n = parseFloat(n));
                for (let e = 0; e < i.length; e += 1) {
                    let a = i[e]
                      , o = a.swiperSlideOffset;
                    t.cssMode && t.centeredSlides && (o -= i[0].swiperSlideOffset);
                    let d = (r + (t.centeredSlides ? this.minTranslate() : 0) - o) / (a.swiperSlideSize + n)
                      , h = (r - l[0] + (t.centeredSlides ? this.minTranslate() : 0) - o) / (a.swiperSlideSize + n)
                      , p = -(r - o)
                      , u = p + this.slidesSizesGrid[e]
                      , c = p >= 0 && p <= this.size - this.slidesSizesGrid[e]
                      , v = p >= 0 && p < this.size - 1 || u > 1 && u <= this.size || p <= 0 && u >= this.size;
                    v && (this.visibleSlides.push(a),
                    this.visibleSlidesIndexes.push(e)),
                    N(a, v, t.slideVisibleClass),
                    N(a, c, t.slideFullyVisibleClass),
                    a.progress = s ? -d : d,
                    a.originalProgress = s ? -h : h
                }
            },
            updateProgress: function(e) {
                if (void 0 === e) {
                    let t = this.rtlTranslate ? -1 : 1;
                    e = this && this.translate && this.translate * t || 0
                }
                let t = this.params
                  , i = this.maxTranslate() - this.minTranslate()
                  , {progress: s, isBeginning: l, isEnd: r, progressLoop: n} = this
                  , a = l
                  , o = r;
                if (0 === i)
                    s = 0,
                    l = !0,
                    r = !0;
                else {
                    s = (e - this.minTranslate()) / i;
                    let t = 1 > Math.abs(e - this.minTranslate())
                      , n = 1 > Math.abs(e - this.maxTranslate());
                    l = t || s <= 0,
                    r = n || s >= 1,
                    t && (s = 0),
                    n && (s = 1)
                }
                if (t.loop) {
                    let t = this.getSlideIndexByData(0)
                      , i = this.getSlideIndexByData(this.slides.length - 1)
                      , s = this.slidesGrid[t]
                      , l = this.slidesGrid[i]
                      , r = this.slidesGrid[this.slidesGrid.length - 1]
                      , a = Math.abs(e);
                    (n = a >= s ? (a - s) / r : (a + r - l) / r) > 1 && (n -= 1)
                }
                Object.assign(this, {
                    progress: s,
                    progressLoop: n,
                    isBeginning: l,
                    isEnd: r
                }),
                (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && this.updateSlidesProgress(e),
                l && !a && this.emit("reachBeginning toEdge"),
                r && !o && this.emit("reachEnd toEdge"),
                (a && !l || o && !r) && this.emit("fromEdge"),
                this.emit("progress", s)
            },
            updateSlidesClasses: function() {
                let e, t;
                let {slides: i, params: s, slidesEl: l, activeIndex: r} = this
                  , n = i[r];
                n && (e = function(e, t) {
                    let i = [];
                    for (; e.nextElementSibling; ) {
                        let s = e.nextElementSibling;
                        t ? s.matches(t) && i.push(s) : i.push(s),
                        e = s
                    }
                    return i
                }(n, `.${s.slideClass}, swiper-slide`)[0],
                t = function(e, t) {
                    let i = [];
                    for (; e.previousElementSibling; ) {
                        let s = e.previousElementSibling;
                        t ? s.matches(t) && i.push(s) : i.push(s),
                        e = s
                    }
                    return i
                }(n, `.${s.slideClass}, swiper-slide`)[0],
                s.loop && !e && (e = i[0]),
                s.loop && !t && (t = i[i.length - 1])),
                i.forEach(i => {
                    G(i, i === n, s.slideActiveClass),
                    G(i, i === e, s.slideNextClass),
                    G(i, i === t, s.slidePrevClass)
                }
                ),
                this.emitSlidesClasses()
            },
            updateActiveIndex: function(e) {
                let t;
                let i = this.rtlTranslate ? this.translate : -this.translate
                  , {snapGrid: s, params: l, activeIndex: r, realIndex: n, snapIndex: a} = this
                  , o = e;
                if (void 0 === o && (o = function(e) {
                    let t;
                    let {slidesGrid: i, params: s} = e
                      , l = e.rtlTranslate ? e.translate : -e.translate;
                    for (let e = 0; e < i.length; e += 1)
                        void 0 !== i[e + 1] ? l >= i[e] && l < i[e + 1] - (i[e + 1] - i[e]) / 2 ? t = e : l >= i[e] && l < i[e + 1] && (t = e + 1) : l >= i[e] && (t = e);
                    return s.normalizeSlideIndex && (t < 0 || void 0 === t) && (t = 0),
                    t
                }(this)),
                s.indexOf(i) >= 0)
                    t = s.indexOf(i);
                else {
                    let e = Math.min(l.slidesPerGroupSkip, o);
                    t = e + Math.floor((o - e) / l.slidesPerGroup)
                }
                if (t >= s.length && (t = s.length - 1),
                o === r && !this.params.loop) {
                    t !== a && (this.snapIndex = t,
                    this.emit("snapIndexChange"));
                    return
                }
                let d = o;
                if (this.slides[o]) {
                    let e = this.slides[o].getAttribute("data-swiper-slide-index");
                    e && (d = parseInt(e, 10))
                }
                Object.assign(this, {
                    previousSnapIndex: a,
                    snapIndex: t,
                    previousRealIndex: n,
                    realIndex: d,
                    previousIndex: r,
                    activeIndex: o
                }),
                this.initialized && $(this),
                this.emit("activeIndexChange"),
                this.emit("snapIndexChange"),
                (this.initialized || this.params.runCallbacksOnInit) && (n !== d && this.emit("realIndexChange"),
                this.emit("slideChange"))
            },
            updateClickedSlide: function(e, t) {
                let i;
                let s = this.params
                  , l = e.closest(`.${s.slideClass}, swiper-slide`);
                !l && this.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach(e => {
                    !l && e.matches && e.matches(`.${s.slideClass}, swiper-slide`) && (l = e)
                }
                );
                let r = !1;
                if (l) {
                    for (let e = 0; e < this.slides.length; e += 1)
                        if (this.slides[e] === l) {
                            r = !0,
                            i = e;
                            break
                        }
                }
                if (l && r)
                    this.clickedSlide = l,
                    this.clickedIndex = i;
                else {
                    this.clickedSlide = void 0,
                    this.clickedIndex = void 0;
                    return
                }
                s.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide()
            }
        },
        translate: {
            getTranslate: function(e) {
                void 0 === e && (e = this.isHorizontal() ? "x" : "y");
                let {params: t, rtlTranslate: i, translate: s, wrapperEl: l} = this;
                if (t.cssMode)
                    return s;
                let r = function(e, t) {
                    let i, s, l;
                    void 0 === t && (t = "x");
                    let r = m()
                      , n = w(e);
                    return r.WebKitCSSMatrix ? ((s = n.transform || n.webkitTransform).split(",").length > 6 && (s = s.split(", ").map(e => e.replace(",", ".")).join(", ")),
                    l = new r.WebKitCSSMatrix("none" === s ? "" : s)) : i = (l = n.MozTransform || n.OTransform || n.MsTransform || n.msTransform || n.transform || n.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","),
                    "x" === t && (s = r.WebKitCSSMatrix ? l.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
                    "y" === t && (s = r.WebKitCSSMatrix ? l.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
                    s || 0
                }(l, e);
                return r += this.cssOverflowAdjustment(),
                i && (r = -r),
                r || 0
            },
            setTranslate: function(e, t) {
                let {rtlTranslate: i, params: s, wrapperEl: l, progress: r} = this
                  , n = 0
                  , a = 0;
                this.isHorizontal() ? n = i ? -e : e : a = e,
                s.roundLengths && (n = Math.floor(n),
                a = Math.floor(a)),
                this.previousTranslate = this.translate,
                this.translate = this.isHorizontal() ? n : a,
                s.cssMode ? l[this.isHorizontal() ? "scrollLeft" : "scrollTop"] = this.isHorizontal() ? -n : -a : (this.isHorizontal() ? n -= this.cssOverflowAdjustment() : a -= this.cssOverflowAdjustment(),
                l.style.transform = `translate3d(${n}px, ${a}px, 0px)`);
                let o = this.maxTranslate() - this.minTranslate();
                (0 === o ? 0 : (e - this.minTranslate()) / o) !== r && this.updateProgress(e),
                this.emit("setTranslate", this.translate, t)
            },
            minTranslate: function() {
                return -this.snapGrid[0]
            },
            maxTranslate: function() {
                return -this.snapGrid[this.snapGrid.length - 1]
            },
            translateTo: function(e, t, i, s, l) {
                let r;
                void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === i && (i = !0),
                void 0 === s && (s = !0);
                let n = this
                  , {params: a, wrapperEl: o} = n;
                if (n.animating && a.preventInteractionOnTransition)
                    return !1;
                let d = n.minTranslate()
                  , h = n.maxTranslate();
                if (r = s && e > d ? d : s && e < h ? h : e,
                n.updateProgress(r),
                a.cssMode) {
                    let e = n.isHorizontal();
                    if (0 === t)
                        o[e ? "scrollLeft" : "scrollTop"] = -r;
                    else {
                        if (!n.support.smoothScroll)
                            return T({
                                swiper: n,
                                targetPosition: -r,
                                side: e ? "left" : "top"
                            }),
                            !0;
                        o.scrollTo({
                            [e ? "left" : "top"]: -r,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                return 0 === t ? (n.setTransition(0),
                n.setTranslate(r),
                i && (n.emit("beforeTransitionStart", t, l),
                n.emit("transitionEnd"))) : (n.setTransition(t),
                n.setTranslate(r),
                i && (n.emit("beforeTransitionStart", t, l),
                n.emit("transitionStart")),
                n.animating || (n.animating = !0,
                n.onTranslateToWrapperTransitionEnd || (n.onTranslateToWrapperTransitionEnd = function(e) {
                    n && !n.destroyed && e.target === this && (n.wrapperEl.removeEventListener("transitionend", n.onTranslateToWrapperTransitionEnd),
                    n.onTranslateToWrapperTransitionEnd = null,
                    delete n.onTranslateToWrapperTransitionEnd,
                    n.animating = !1,
                    i && n.emit("transitionEnd"))
                }
                ),
                n.wrapperEl.addEventListener("transitionend", n.onTranslateToWrapperTransitionEnd))),
                !0
            }
        },
        transition: {
            setTransition: function(e, t) {
                this.params.cssMode || (this.wrapperEl.style.transitionDuration = `${e}ms`,
                this.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""),
                this.emit("setTransition", e, t)
            },
            transitionStart: function(e, t) {
                void 0 === e && (e = !0);
                let {params: i} = this;
                i.cssMode || (i.autoHeight && this.updateAutoHeight(),
                V({
                    swiper: this,
                    runCallbacks: e,
                    direction: t,
                    step: "Start"
                }))
            },
            transitionEnd: function(e, t) {
                void 0 === e && (e = !0);
                let {params: i} = this;
                this.animating = !1,
                i.cssMode || (this.setTransition(0),
                V({
                    swiper: this,
                    runCallbacks: e,
                    direction: t,
                    step: "End"
                }))
            }
        },
        slide: {
            slideTo: function(e, t, i, s, l) {
                let r;
                void 0 === e && (e = 0),
                void 0 === i && (i = !0),
                "string" == typeof e && (e = parseInt(e, 10));
                let n = this
                  , a = e;
                a < 0 && (a = 0);
                let {params: o, snapGrid: d, slidesGrid: h, previousIndex: p, activeIndex: u, rtlTranslate: c, wrapperEl: v, enabled: m} = n;
                if (!m && !s && !l || n.destroyed || n.animating && o.preventInteractionOnTransition)
                    return !1;
                void 0 === t && (t = n.params.speed);
                let g = Math.min(n.params.slidesPerGroupSkip, a)
                  , f = g + Math.floor((a - g) / n.params.slidesPerGroup);
                f >= d.length && (f = d.length - 1);
                let w = -d[f];
                if (o.normalizeSlideIndex)
                    for (let e = 0; e < h.length; e += 1) {
                        let t = -Math.floor(100 * w)
                          , i = Math.floor(100 * h[e])
                          , s = Math.floor(100 * h[e + 1]);
                        void 0 !== h[e + 1] ? t >= i && t < s - (s - i) / 2 ? a = e : t >= i && t < s && (a = e + 1) : t >= i && (a = e)
                    }
                if (n.initialized && a !== u && (!n.allowSlideNext && (c ? w > n.translate && w > n.minTranslate() : w < n.translate && w < n.minTranslate()) || !n.allowSlidePrev && w > n.translate && w > n.maxTranslate() && (u || 0) !== a))
                    return !1;
                if (a !== (p || 0) && i && n.emit("beforeSlideChangeStart"),
                n.updateProgress(w),
                r = a > u ? "next" : a < u ? "prev" : "reset",
                c && -w === n.translate || !c && w === n.translate)
                    return n.updateActiveIndex(a),
                    o.autoHeight && n.updateAutoHeight(),
                    n.updateSlidesClasses(),
                    "slide" !== o.effect && n.setTranslate(w),
                    "reset" !== r && (n.transitionStart(i, r),
                    n.transitionEnd(i, r)),
                    !1;
                if (o.cssMode) {
                    let e = n.isHorizontal()
                      , i = c ? w : -w;
                    if (0 === t)
                        v[e ? "scrollLeft" : "scrollTop"] = i;
                    else {
                        if (!n.support.smoothScroll)
                            return T({
                                swiper: n,
                                targetPosition: i,
                                side: e ? "left" : "top"
                            }),
                            !0;
                        v.scrollTo({
                            [e ? "left" : "top"]: i,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                let S = B();
                return S.isSafari,
                n.setTransition(t),
                n.setTranslate(w),
                n.updateActiveIndex(a),
                n.updateSlidesClasses(),
                n.emit("beforeTransitionStart", t, s),
                n.transitionStart(i, r),
                0 === t ? n.transitionEnd(i, r) : n.animating || (n.animating = !0,
                n.onSlideToWrapperTransitionEnd || (n.onSlideToWrapperTransitionEnd = function(e) {
                    n && !n.destroyed && e.target === this && (n.wrapperEl.removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd),
                    n.onSlideToWrapperTransitionEnd = null,
                    delete n.onSlideToWrapperTransitionEnd,
                    n.transitionEnd(i, r))
                }
                ),
                n.wrapperEl.addEventListener("transitionend", n.onSlideToWrapperTransitionEnd)),
                !0
            },
            slideToLoop: function(e, t, i, s) {
                if (void 0 === e && (e = 0),
                void 0 === i && (i = !0),
                "string" == typeof e) {
                    let t = parseInt(e, 10);
                    e = t
                }
                let l = this;
                if (l.destroyed)
                    return;
                void 0 === t && (t = l.params.speed);
                let r = e;
                if (l.params.loop) {
                    let e;
                    l.slides;
                    let t = l.slides.length;
                    e = l.getSlideIndexByData(r);
                    let i = l.slides.length
                      , {centeredSlides: n} = l.params
                      , a = l.params.slidesPerView;
                    "auto" === a ? a = l.slidesPerViewDynamic() : (a = Math.ceil(parseFloat(l.params.slidesPerView, 10)),
                    n && a % 2 == 0 && (a += 1));
                    let o = i - e < a;
                    if (n && (o = o || e < Math.ceil(a / 2)),
                    s && n && "auto" !== l.params.slidesPerView && (o = !1),
                    n && o) {
                        let t = n ? e < l.activeIndex ? "prev" : "next" : e - l.activeIndex - 1 < l.params.slidesPerView ? "next" : "prev";
                        l.loopFix({
                            direction: t,
                            slideTo: !0,
                            activeSlideIndex: "next" === t ? e + 1 : e - i + 1,
                            slideRealIndex: "next" === t ? l.realIndex : void 0
                        })
                    }
                    if (!n && o) {
                        let s, n, a;
                        l.activeIndex < e ? (n = e - l.activeIndex,
                        a = l.activeIndex - (e - t)) : (a = l.activeIndex - e,
                        n = e + t - l.activeIndex),
                        s = n > a ? "prev" : "next",
                        l.loopFixDot({
                            direction: s,
                            slideTo: !0,
                            activeSlideIndex: "next" === s ? e + 1 : e - i + 1,
                            slideRealIndex: "next" === s ? l.realIndex : void 0,
                            targetSlideIndex: e,
                            newIndex: l.getSlideIndexByData(r)
                        })
                    }
                    r = l.getSlideIndexByData(r)
                }
                return requestAnimationFrame( () => {
                    l.slideTo(r, t, i, s)
                }
                ),
                l
            },
            slideToLoopCenterSneakPeek: function(e, t, i, s) {
                if (void 0 === e && (e = 0),
                void 0 === i && (i = !0),
                "string" == typeof e) {
                    let t = parseInt(e, 10);
                    e = t
                }
                if (this.destroyed)
                    return;
                void 0 === t && (t = this.params.speed);
                let l = e;
                if (this.params.loop) {
                    let e;
                    this.slides;
                    let t = this.slides.length;
                    e = this.getSlideIndexByData(l);
                    let i = this.slides.length
                      , {centeredSlides: r} = this.params
                      , n = this.params.slidesPerView;
                    "auto" === n ? n = this.slidesPerViewDynamic() : (n = Math.ceil(parseFloat(this.params.slidesPerView, 10)),
                    r && n % 2 == 0 && (n += 1)),
                    s && r && this.params.slidesPerView;
                    let a = this.params?.isSneakPeekCenter;
                    if (a) {
                        let s, r, n;
                        this.activeIndex < e ? (r = e - this.activeIndex,
                        n = this.activeIndex - (e - t)) : (n = this.activeIndex - e,
                        r = e + t - this.activeIndex),
                        s = r > n ? "prev" : "next",
                        this.loopFixDot({
                            direction: s,
                            slideTo: !0,
                            activeSlideIndex: "next" === s ? e + 1 : e - i + 1,
                            slideRealIndex: "next" === s ? this.realIndex : void 0,
                            targetSlideIndex: e,
                            newIndex: this.getSlideIndexByData(l)
                        })
                    }
                    l = this.getSlideIndexByData(l)
                }
                this.slideTo(l, t, i, s);
                let r = this.slides;
                if (this.params?.isSneakPeekCenter && r.length > 1 && 0 === this.activeIndex) {
                    let e = Math.abs(this.snapGrid[1] - this.snapGrid[0])
                      , t = JSON.parse(JSON.stringify(this.snapGrid[1]))
                      , i = r[r.length - 1];
                    i.swiperLoopMoveDOM = !0,
                    this.slidesEl.prepend(i),
                    i.swiperLoopMoveDOM = !1,
                    this.setTransition(0),
                    this.setTranslate(-(t + e)),
                    this.recalcSlides(),
                    this.updateSlides(),
                    this.setTransition(this.params.speed),
                    this.setTranslate(-t)
                }
            },
            slideNext: function(e, t, i) {
                void 0 === t && (t = !0);
                let s = this
                  , {enabled: l, params: r, animating: n} = s;
                if (!l || s.destroyed)
                    return s;
                void 0 === e && (e = s.params.speed);
                let a = r.slidesPerGroup;
                "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (a = Math.max(s.slidesPerViewDynamic("current", !0), 1));
                let o = s.activeIndex < r.slidesPerGroupSkip ? 1 : a;
                if (r.loop) {
                    if (n && r.loopPreventsSliding)
                        return !1;
                    let l = "auto" === r.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10));
                    if (s.slides.length >= l && (s.loopFix({
                        direction: "next"
                    }),
                    s._clientLeft = s.wrapperEl.clientLeft),
                    s.activeIndex === s.slides.length - 1 && r.cssMode)
                        return requestAnimationFrame( () => {
                            s.slideTo(s.activeIndex + o, e, t, i)
                        }
                        ),
                        !0
                }
                if (r.rewind && s.isEnd)
                    return s.slideTo(0, e, t, i);
                requestAnimationFrame( () => {
                    s.slideTo(s.activeIndex + o, e, t, i);
                    let l = s.slides;
                    if (s.params?.isSneakPeekCenter && l.length > 1 && (s.activeIndex === l.length - 1 || s.isEnd)) {
                        let e = s.snapGrid.length - 1
                          , t = Math.abs(s.snapGrid[e] - s.snapGrid[e - 1])
                          , i = structuredClone(s.snapGrid[e - 1]);
                        if (!s.params.loop)
                            return;
                        let r = l[0];
                        r.swiperLoopMoveDOM = !0,
                        s.slidesEl.append(r),
                        r.swiperLoopMoveDOM = !1,
                        s.setTransition(0),
                        s.setTranslate(-(i - t)),
                        s.recalcSlides(),
                        s.updateSlides(),
                        s.setTransition(s.params.speed),
                        s.setTranslate(-i)
                    }
                }
                )
            },
            slidePrev: function(e, t, i) {
                void 0 === t && (t = !0);
                let s = this
                  , {params: l, snapGrid: r, slidesGrid: n, rtlTranslate: a, enabled: o} = s;
                if (!o || s.destroyed)
                    return s;
                if (void 0 === e && (e = s.params.speed),
                l.loop) {
                    let e = "auto" === l.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(l.slidesPerView, 10));
                    s.slides.length >= e && (s.loopFix({
                        direction: "prev"
                    }),
                    s._clientLeft = s.wrapperEl.clientLeft)
                }
                let d = a ? s.translate : -s.translate;
                function h(e) {
                    return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                }
                let p = h(d)
                  , u = r.map(e => h(e))
                  , c = r[u.indexOf(p) - 1];
                if (void 0 === c && l.cssMode) {
                    let e;
                    r.forEach( (t, i) => {
                        p >= t && (e = i)
                    }
                    ),
                    void 0 !== e && (c = r[e > 0 ? e - 1 : e])
                }
                let v = 0;
                if (void 0 !== c && ((v = n.indexOf(c)) < 0 && (v = s.activeIndex - 1),
                "auto" === l.slidesPerView && 1 === l.slidesPerGroup && l.slidesPerGroupAuto && (v = Math.max(v = v - s.slidesPerViewDynamic("previous", !0) + 1, 0))),
                l.rewind && s.isBeginning) {
                    let l = s.slides.length - 1;
                    return s.slideTo(l, e, t, i)
                }
                if (l.loop && 0 === s.activeIndex && l.cssMode)
                    return requestAnimationFrame( () => {
                        s.slideTo(v, e, t, i)
                    }
                    ),
                    !0;
                requestAnimationFrame( () => {
                    s.slideTo(v, e, t, i);
                    let l = s.slides;
                    if (s.params?.isSneakPeekCenter && l.length > 1 && 0 === s.activeIndex) {
                        let e = Math.abs(s.snapGrid[1] - s.snapGrid[0])
                          , t = JSON.parse(JSON.stringify(s.snapGrid[1]));
                        if (!s.params.loop)
                            return;
                        let i = l[l.length - 1];
                        i.swiperLoopMoveDOM = !0,
                        s.slidesEl.prepend(i),
                        i.swiperLoopMoveDOM = !1,
                        s.setTransition(0),
                        s.setTranslate(-(t + e)),
                        s.recalcSlides(),
                        s.updateSlides(),
                        s.setTransition(s.params.speed),
                        s.setTranslate(-t)
                    }
                }
                )
            },
            slideReset: function(e, t, i) {
                if (void 0 === t && (t = !0),
                !this.destroyed)
                    return void 0 === e && (e = this.params.speed),
                    this.slideTo(this.activeIndex, e, t, i)
            },
            slideToClosest: function(e, t, i, s) {
                if (void 0 === t && (t = !0),
                void 0 === s && (s = .5),
                this.destroyed)
                    return;
                void 0 === e && (e = this.params.speed);
                let l = this.activeIndex
                  , r = Math.min(this.params.slidesPerGroupSkip, l)
                  , n = r + Math.floor((l - r) / this.params.slidesPerGroup)
                  , a = this.rtlTranslate ? this.translate : -this.translate;
                if (a >= this.snapGrid[n]) {
                    let e = this.snapGrid[n]
                      , t = this.snapGrid[n + 1];
                    a - e > (t - e) * s && (l += this.params.slidesPerGroup)
                } else {
                    let e = this.snapGrid[n - 1]
                      , t = this.snapGrid[n];
                    a - e <= (t - e) * s && (l -= this.params.slidesPerGroup)
                }
                return l = Math.min(l = Math.max(l, 0), this.slidesGrid.length - 1),
                this.slideTo(l, e, t, i)
            },
            slideToClickedSlide: function() {
                let e;
                let t = this;
                if (t.destroyed)
                    return;
                let {params: i, slidesEl: s} = t
                  , l = "auto" === i.slidesPerView ? t.slidesPerViewDynamic() : i.slidesPerView
                  , r = t.clickedIndex
                  , n = t.isElement ? "swiper-slide" : `.${i.slideClass}`;
                if (i.loop) {
                    if (t.animating)
                        return;
                    if (e = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10),
                    i.centeredSlides)
                        t.slideToLoop(e);
                    else if (r > t.slides.length - l) {
                        t.loopFix();
                        let i = x(s, `${n}[data-swiper-slide-index="${e}"]`)[0];
                        g( () => {
                            i && t.slideTo(t.getSlideIndex(i))
                        }
                        )
                    } else
                        t.slideTo(r)
                } else
                    t.slideTo(r)
            }
        },
        loop: {
            loopCreate: function(e, t) {
                let i = this
                  , {params: s, slidesEl: l} = i;
                if (!s.loop)
                    return;
                let r = () => {
                    let e = x(l, `.${s.slideClass}, swiper-slide`);
                    e.forEach( (e, t) => {
                        e.setAttribute("data-swiper-slide-index", t)
                    }
                    )
                }
                ;
                s.loopAddBlankSlides && s.slidesPerGroup > 1 && ( () => {
                    let e = x(l, `.${s.slideBlankClass}`);
                    e.forEach(e => e.remove()),
                    e.length > 0 && (i.recalcSlides(),
                    i.updateSlides())
                }
                )();
                let n = s.slidesPerGroup
                  , a = i.slides.length % n != 0;
                if (a) {
                    if (s.loopAddBlankSlides) {
                        let e = n - i.slides.length % n;
                        (e => {
                            for (let t = 0; t < e; t += 1) {
                                let e = i.isElement ? I("swiper-slide", [s.slideBlankClass]) : I("div", [s.slideClass, s.slideBlankClass]);
                                i.slidesEl.append(e)
                            }
                        }
                        )(e),
                        i.recalcSlides(),
                        i.updateSlides()
                    } else
                        E("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
                    r()
                } else
                    r();
                i.loopFix({
                    slideRealIndex: e,
                    direction: s.centeredSlides ? void 0 : "next",
                    initial: t
                })
            },
            loopFix: function(e) {
                let {slideRealIndex: t, slideTo: i=!0, direction: s, setTranslate: l, activeSlideIndex: r, initial: n, byMousewheel: a} = void 0 === e ? {} : e
                  , o = this;
                if (!o.params.loop)
                    return;
                let d = "auto" === o.params.slidesPerView ? o.slidesPerViewDynamic() : Math.ceil(parseFloat(o.params.slidesPerView, 10));
                if (o.slides.length < d) {
                    console.warn("Swiper: Loop mode disabled - slides.length < slidesPerView");
                    return
                }
                o.emit("beforeLoopFix");
                let {slides: h, allowSlidePrev: p, allowSlideNext: u, slidesEl: c, params: v} = o
                  , {centeredSlides: m, initialSlide: g} = v;
                o.allowSlidePrev = !0,
                o.allowSlideNext = !0;
                let f = v.slidesPerView;
                "auto" === f ? f = o.slidesPerViewDynamic() : (f = Math.ceil(parseFloat(v.slidesPerView, 10)),
                m && f % 2 == 0 && (f += 1));
                let w = v.slidesPerGroupAuto ? f : v.slidesPerGroup
                  , S = m ? Math.max(w, Math.ceil(f / 2)) : w;
                S % w != 0 && (S += w - S % w),
                S += v.loopAdditionalSlides,
                o.loopedSlides = S,
                h.length < f + S && E("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
                let b = []
                  , y = []
                  , T = h.length
                  , x = n && T - g < f && !m
                  , I = x ? g : o.activeIndex;
                void 0 === r ? r = o.getSlideIndex(h.find(e => e.classList.contains(v.slideActiveClass))) : I = r;
                let C = "next" === s || !s
                  , k = "prev" === s || !s
                  , P = 0
                  , M = 0
                  , L = r
                  , D = L + (m && void 0 === l ? -f / 2 + .5 : 0);
                if (D < S) {
                    P = Math.max(S - D, w);
                    for (let e = 0; e < S - D; e += 1) {
                        let t = e - Math.floor(e / T) * T;
                        b.push(T - t - 1)
                    }
                } else if (D + f > T - S) {
                    M = Math.max(D - (T - 2 * S), w),
                    x && (M = Math.max(M, f - T + g + 1));
                    for (let e = 0; e < M; e += 1) {
                        let t = e - Math.floor(e / T) * T;
                        y.push(t)
                    }
                }
                if (o.__preventObserver__ = !0,
                requestAnimationFrame( () => {
                    o.__preventObserver__ = !1
                }
                ),
                k && b.forEach(e => {
                    h[e].swiperLoopMoveDOM = !0,
                    c.prepend(h[e]),
                    h[e].swiperLoopMoveDOM = !1
                }
                ),
                C && y.forEach(e => {
                    h[e].swiperLoopMoveDOM = !0,
                    c.append(h[e]),
                    h[e].swiperLoopMoveDOM = !1
                }
                ),
                o.recalcSlides(),
                "auto" === v.slidesPerView && o.updateSlides(),
                v.watchSlidesProgress && o.updateSlidesOffset({
                    isCalculatedFromUpdateSlides: n && "auto" === v.slidesPerView
                }),
                i) {
                    if (b.length > 0 && k) {
                        if (void 0 === t) {
                            let e = o.slidesGrid[I]
                              , t = o.slidesGrid[I + P]
                              , i = t - e;
                            a ? o.setTranslate(o.translate - i) : (o.slideTo(I + Math.ceil(P), 0, !1, !0),
                            l && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - i,
                            o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - i))
                        } else if (l) {
                            let e = b.length;
                            o.slideTo(o.activeIndex + e, 0, !1, !0),
                            o.touchEventsData.currentTranslate = o.translate
                        }
                    } else if (y.length > 0 && C) {
                        if (void 0 === t) {
                            let e = o.slidesGrid[I]
                              , t = o.slidesGrid[I - M]
                              , i = t - e;
                            a ? o.setTranslate(o.translate - i) : (o.slideTo(I - M, 0, !1, !0),
                            l && (o.touchEventsData.startTranslate = o.touchEventsData.startTranslate - i,
                            o.touchEventsData.currentTranslate = o.touchEventsData.currentTranslate - i))
                        } else {
                            let e = y.length;
                            o.slideTo(o.activeIndex - e, 0, !1, !0)
                        }
                    }
                }
                o.allowSlidePrev = p,
                o.allowSlideNext = u,
                o.emit("loopFix")
            },
            loopFixDot: function(e) {
                let {slideRealIndex: t, slideTo: i=!0, direction: s, activeSlideIndex: l, initial: r, targetSlideIndex: n, newIndex: a} = void 0 === e ? {} : e;
                if (!this.params.loop)
                    return;
                let o = "auto" === this.params.slidesPerView ? this.slidesPerViewDynamic() : Math.ceil(parseFloat(this.params.slidesPerView, 10));
                if (this.slides.length < o) {
                    console.warn("Swiper: Loop mode disabled - slides.length < slidesPerView");
                    return
                }
                this.emit("beforeLoopFix");
                let {slides: d, allowSlidePrev: h, allowSlideNext: p, slidesEl: u, params: c} = this
                  , v = u.children[n].getAttribute("data-swiper-slide-index")
                  , m = Array.from(u.children).find(e => e.classList.contains(c.slideActiveClass)).getAttribute("data-swiper-slide-index")
                  , {centeredSlides: g, initialSlide: f} = c
                  , w = u.children[this.activeIndex].getAttribute("data-swiper-slide-index");
                this.allowSlidePrev = !0,
                this.allowSlideNext = !0;
                let S = c.slidesPerView;
                "auto" === S ? S = this.slidesPerViewDynamic() : (S = Math.ceil(parseFloat(c.slidesPerView, 10)),
                g && S % 2 == 0 && (S += 1));
                let b = c.slidesPerGroupAuto ? S : c.slidesPerGroup
                  , y = g ? Math.max(b, Math.ceil(S / 2)) : b;
                y % b != 0 && (y += b - y % b),
                y += c.loopAdditionalSlides,
                this.loopedSlides = y,
                d.length < S + y && E("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
                let T = "next" === s || !s
                  , x = "prev" === s || !s
                  , I = []
                  , C = [];
                for (let e = 0; e < u.children.length; e++)
                    C.push(u.children[e].getAttribute("data-swiper-slide-index"));
                if (x)
                    for (let e = n; e < u.children.length; e++)
                        I.push(e);
                else if (T)
                    for (let e = 0; e < S - (u.children.length - n); e++)
                        I.push(e);
                let k = d.length
                  , P = r && k - f < S && !g;
                P || this.activeIndex,
                void 0 === l && (l = this.getSlideIndex(d.find(e => e.classList.contains(c.slideActiveClass))));
                let M = document.createDocumentFragment();
                (T ? I : I.reverse()).forEach(e => {
                    if (d[e]) {
                        let t = d[e]
                          , i = t.cloneNode(!0);
                        i.setAttribute("data-swiper-clone", "true"),
                        i.classList.add("swiper-slide-clone"),
                        M.appendChild(i)
                    }
                }
                ),
                x && I.forEach(e => {
                    let t = d[e];
                    t.swiperLoopMoveDOM = !0,
                    u.prepend(t),
                    t.swiperLoopMoveDOM = !1
                }
                ),
                T && I.forEach(e => {
                    let t = d[e];
                    t.swiperLoopMoveDOM = !0,
                    u.append(t),
                    t.swiperLoopMoveDOM = !1
                }
                );
                let L = Array.from(M.children);
                L.sort( (e, t) => {
                    let i = parseInt(e.getAttribute("data-swiper-slide-index")) || 0
                      , s = parseInt(t.getAttribute("data-swiper-slide-index")) || 0;
                    return i - s
                }
                ),
                M.innerHTML = "",
                L.forEach(e => {
                    M.appendChild(e)
                }
                ),
                x ? u.appendChild(M) : T && u.insertBefore(M, u.firstChild),
                this.recalcSlides(),
                this.updateSlides();
                let D = null;
                for (let e = 0; e < u.children.length; e++) {
                    let t = u.children[e];
                    if (t.getAttribute("data-swiper-slide-index") === w) {
                        D = e;
                        break
                    }
                }
                i && D !== this.activeIndex && this.slideTo(D, 0);
                let A = Math.min(this.params.slidesPerGroupSkip, a)
                  , O = A + Math.floor((a - A) / this.params.slidesPerGroup);
                O >= this.snapGrid.length && (O = this.snapGrid.length - 1);
                let z = -this.snapGrid[O];
                if (z === this.translate) {
                    let e, t;
                    for (let t = 0; t < u.children.length; t++) {
                        let i = u.children[t];
                        if (i.getAttribute("data-swiper-slide-index") === w) {
                            e = t;
                            break
                        }
                    }
                    let i = Math.min(this.params.slidesPerGroupSkip, e)
                      , s = i + Math.floor((e - i) / this.params.slidesPerGroup);
                    s >= this.snapGrid.length && (s = this.snapGrid.length - 1);
                    let l = -this.snapGrid[s];
                    t = l === this.translate ? this.snapGrid[s > 0 ? s - 1 : this.snapGrid.length - 1] : l,
                    this.setTranslate(t)
                }
                let B = u.querySelectorAll('[data-swiper-clone="true"]');
                B.forEach(e => {
                    e.parentNode && e.parentNode.removeChild(e)
                }
                ),
                this.recalcSlides(),
                this.updateSlides();
                let N = Array.from(u.children).findIndex(e => 1 * e.getAttribute("data-swiper-slide-index") == 1 * v)
                  , G = Array.from(u.children).findIndex(e => 1 * e.getAttribute("data-swiper-slide-index") == 1 * m)
                  , F = A + Math.floor((N - A) / this.params.slidesPerGroup)
                  , _ = A + Math.floor((G - A) / this.params.slidesPerGroup);
                if (i && F === N) {
                    let e = -this.snapGrid[_ > this.snapGrid.length - 1 ? F - 1 > this.snapGrid.length - 1 ? 0 : F - 1 : _];
                    this.setTranslate(e)
                }
                this.recalcSlides(),
                this.updateSlides(),
                this.allowSlidePrev = h,
                this.allowSlideNext = p,
                this.emit("loopFixDot")
            },
            loopDestroy: function() {
                let {params: e, slidesEl: t} = this;
                if (!e.loop || !t)
                    return;
                this.recalcSlides();
                let i = [];
                this.slides.forEach(e => {
                    let t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                    i[t] = e
                }
                ),
                this.slides.forEach(e => {
                    e.removeAttribute("data-swiper-slide-index")
                }
                ),
                i.forEach(e => {
                    t.append(e)
                }
                ),
                this.recalcSlides(),
                this.slideTo(this.realIndex, 0)
            }
        },
        grabCursor: {
            setGrabCursor: function(e) {
                let t = this;
                if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)
                    return;
                let i = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                t.isElement && (t.__preventObserver__ = !0),
                i.style.cursor = "move",
                i.style.cursor = e ? "grabbing" : "grab",
                t.isElement && requestAnimationFrame( () => {
                    t.__preventObserver__ = !1
                }
                )
            },
            unsetGrabCursor: function() {
                let e = this;
                e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0),
                e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "",
                e.isElement && requestAnimationFrame( () => {
                    e.__preventObserver__ = !1
                }
                ))
            }
        },
        events: {
            attachEvents: function() {
                let {params: e} = this;
                this.onTouchStart = H.bind(this),
                this.onTouchMove = W.bind(this),
                this.onTouchEnd = q.bind(this),
                this.onDocumentTouchStart = K.bind(this),
                e.cssMode && (this.onScroll = Y.bind(this)),
                this.onClick = X.bind(this),
                this.onLoad = U.bind(this),
                Q(this, "on")
            },
            detachEvents: function() {
                Q(this, "off")
            }
        },
        breakpoints: {
            setBreakpoint: function() {
                let e = this
                  , {realIndex: t, initialized: i, params: s, el: l} = e
                  , r = s.breakpoints;
                if (!r || r && 0 === Object.keys(r).length)
                    return;
                let n = c()
                  , a = "window" !== s.breakpointsBase && s.breakpointsBase ? "container" : s.breakpointsBase
                  , o = ["window", "container"].includes(s.breakpointsBase) || !s.breakpointsBase ? e.el : n.querySelector(s.breakpointsBase)
                  , d = e.getBreakpoint(r, a, o);
                if (!d || e.currentBreakpoint === d)
                    return;
                let h = d in r ? r[d] : void 0
                  , p = h || e.originalParams
                  , u = e.params.grabCursor
                  , v = p.grabCursor
                  , m = s.enabled;
                u && !v ? e.unsetGrabCursor() : !u && v && e.setGrabCursor(),
                ["navigation", "pagination"].forEach(t => {
                    void 0 !== p[t] && J(e, s, p, t)
                }
                );
                let g = p.direction && p.direction !== s.direction
                  , f = s.loop && (p.slidesPerView !== s.slidesPerView || g)
                  , w = s.loop;
                g && i && e.changeDirection(),
                b(e.params, p);
                let S = e.params.enabled
                  , y = e.params.loop;
                Object.assign(e, {
                    allowTouchMove: e.params.allowTouchMove,
                    allowSlideNext: e.params.allowSlideNext,
                    allowSlidePrev: e.params.allowSlidePrev
                }),
                m && !S ? e.disable() : !m && S && e.enable(),
                e.currentBreakpoint = d,
                e.emit("_beforeBreakpoint", p),
                i && (f ? (e.loopDestroy(),
                e.loopCreate(t),
                e.updateSlides()) : !w && y ? (e.loopCreate(t),
                e.updateSlides()) : w && !y && e.loopDestroy()),
                e.emit("breakpoint", p)
            },
            getBreakpoint: function(e, t, i) {
                if (void 0 === t && (t = "window"),
                !e || "container" === t && !i)
                    return;
                let s = !1
                  , l = m()
                  , r = "window" === t
                  , n = r ? {
                    width: 0,
                    height: 0
                } : {
                    width: i.clientWidth,
                    height: i.clientHeight
                }
                  , a = Object.keys(e).map(e => {
                    if ("string" == typeof e && 0 === e.indexOf("@")) {
                        let t = parseFloat(e.substr(1))
                          , i = (r ? Z.getScreenSizeObject().getWindowSize().height : n.height) * t;
                        return {
                            value: i,
                            point: e
                        }
                    }
                    return {
                        value: e,
                        point: e
                    }
                }
                );
                a.sort( (e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                for (let e = 0; e < a.length; e += 1) {
                    let {point: t, value: i} = a[e];
                    r ? l.matchMedia(`(min-width: ${i}px)`).matches && (s = t) : i <= n.width && (s = t)
                }
                return s || "max"
            }
        },
        checkOverflow: {
            checkOverflow: function() {
                let {isLocked: e, params: t} = this
                  , i = t.slidesOffsetBefore || 0
                  , s = t.slidesOffsetAfter || 0;
                if (i > 0 || s > 0) {
                    let e = this.slides.length - 1
                      , t = this.slidesGrid[e] + this.slidesSizesGrid[e] + i + s;
                    this.isLocked = this.size > t
                } else
                    this.isLocked = 1 === this.snapGrid.length;
                !0 === t.allowSlideNext && (this.allowSlideNext = !this.isLocked),
                !0 === t.allowSlidePrev && (this.allowSlidePrev = !this.isLocked),
                e && e !== this.isLocked && (this.isEnd = !1),
                e !== this.isLocked && this.emit(this.isLocked ? "lock" : "unlock")
            }
        },
        classes: {
            addClasses: function() {
                let {classNames: e, params: t, rtl: i, el: s, device: l} = this
                  , r = ee(["initialized", t.direction, {
                    autoheight: t.autoHeight
                }, {
                    rtl: i
                }, {
                    android: l.android
                }, {
                    ios: l.ios
                }, {
                    "css-mode": t.cssMode
                }, {
                    centered: t.cssMode && t.centeredSlides
                }, {
                    "watch-progress": t.watchSlidesProgress
                }], t.containerModifierClass);
                e.push(...r),
                s.classList.add(...e),
                this.emitContainerClasses()
            },
            removeClasses: function() {
                let {el: e, classNames: t} = this;
                e && "string" != typeof e && (e.classList.remove(...t),
                this.emitContainerClasses())
            }
        }
    }
      , es = {};
    class el {
        constructor() {
            let e, t;
            for (var i = arguments.length, s = Array(i), l = 0; l < i; l++)
                s[l] = arguments[l];
            1 === s.length && s[0].constructor && "Object" === Object.prototype.toString.call(s[0]).slice(8, -1) ? t = s[0] : [e,t] = s,
            t || (t = {}),
            t = b({}, t),
            e && !t.el && (t.el = e);
            let r = c();
            if (t.el && "string" == typeof t.el && r.querySelectorAll(t.el).length > 1) {
                let e = [];
                return r.querySelectorAll(t.el).forEach(i => {
                    let s = b({}, t, {
                        el: i
                    });
                    e.push(new el(s))
                }
                ),
                e
            }
            let n = this;
            n.__swiper__ = !0,
            n.support = O(),
            n.device = z({
                userAgent: t.userAgent
            }),
            n.browser = B(),
            n.eventsListeners = {},
            n.eventsAnyListeners = [],
            n.modules = [...n.__modules__],
            t.modules && Array.isArray(t.modules) && n.modules.push(...t.modules);
            let a = {};
            n.modules.forEach(e => {
                var i;
                e({
                    params: t,
                    swiper: n,
                    extendParams: (i = t,
                    function(e) {
                        void 0 === e && (e = {});
                        let t = Object.keys(e)[0]
                          , s = e[t];
                        if ("object" != typeof s || null === s || (!0 === i[t] && (i[t] = {
                            enabled: !0
                        }),
                        "navigation" === t && i[t] && i[t].enabled && !i[t].prevEl && !i[t].nextEl && (i[t].auto = !0),
                        "pagination" === t && i[t] && i[t].enabled && !i[t].el && (i[t].auto = !0),
                        !(t in i && "enabled"in s))) {
                            b(a, e);
                            return
                        }
                        "object" != typeof i[t] || "enabled"in i[t] || (i[t].enabled = !0),
                        i[t] || (i[t] = {
                            enabled: !1
                        }),
                        b(a, e)
                    }
                    ),
                    on: n.on.bind(n),
                    once: n.once.bind(n),
                    off: n.off.bind(n),
                    emit: n.emit.bind(n)
                })
            }
            );
            let o = b({}, et, a);
            return n.params = b({}, o, es, t),
            n.originalParams = b({}, n.params),
            n.passedParams = b({}, t),
            n.params && n.params.on && Object.keys(n.params.on).forEach(e => {
                n.on(e, n.params.on[e])
            }
            ),
            n.params && n.params.onAny && n.onAny(n.params.onAny),
            Object.assign(n, {
                enabled: n.params.enabled,
                el: e,
                classNames: [],
                slides: [],
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: () => "horizontal" === n.params.direction,
                isVertical: () => "vertical" === n.params.direction,
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                cssOverflowAdjustment() {
                    return 8388608 * Math.trunc(this.translate / 8388608)
                },
                allowSlideNext: n.params.allowSlideNext,
                allowSlidePrev: n.params.allowSlidePrev,
                touchEventsData: {
                    isTouched: void 0,
                    isMoved: void 0,
                    allowTouchCallbacks: void 0,
                    touchStartTime: void 0,
                    isScrolling: void 0,
                    currentTranslate: void 0,
                    startTranslate: void 0,
                    allowThresholdMove: void 0,
                    focusableElements: n.params.focusableElements,
                    lastClickTime: 0,
                    clickTimeout: void 0,
                    velocities: [],
                    allowMomentumBounce: void 0,
                    startMoving: void 0,
                    pointerId: null,
                    touchId: null
                },
                allowClick: !0,
                allowTouchMove: n.params.allowTouchMove,
                touches: {
                    startX: 0,
                    startY: 0,
                    currentX: 0,
                    currentY: 0,
                    diff: 0
                },
                imagesToLoad: [],
                imagesLoaded: 0,
                rtl: t?.rtl,
                __addedToDOM__: !1
            }),
            n.emit("_swiper"),
            n.params.init && n.init(),
            n
        }
        getDirectionLabel(e) {
            return this.isHorizontal() ? e : ({
                width: "height",
                "margin-top": "margin-left",
                "margin-bottom ": "margin-right",
                "margin-left": "margin-top",
                "margin-right": "margin-bottom",
                "padding-left": "padding-top",
                "padding-right": "padding-bottom",
                marginRight: "marginBottom"
            })[e]
        }
        getSlideIndex(e) {
            let {slidesEl: t, params: i} = this
              , s = x(t, `.${i.slideClass}, swiper-slide`)
              , l = k(s[0]);
            return k(e) - l
        }
        getSlideIndexByData(e) {
            return this.getSlideIndex(this.slides.find(t => 1 * t.getAttribute("data-swiper-slide-index") === e))
        }
        recalcSlides() {
            let {slidesEl: e, params: t} = this;
            this.slides = x(e, `.${t.slideClass}, swiper-slide`)
        }
        enable() {
            this.enabled || (this.enabled = !0,
            this.params.grabCursor && this.setGrabCursor(),
            this.emit("enable"))
        }
        disable() {
            this.enabled && (this.enabled = !1,
            this.params.grabCursor && this.unsetGrabCursor(),
            this.emit("disable"))
        }
        setProgress(e, t) {
            e = Math.min(Math.max(e, 0), 1);
            let i = this.minTranslate()
              , s = this.maxTranslate()
              , l = (s - i) * e + i;
            this.translateTo(l, void 0 === t ? 0 : t),
            this.updateActiveIndex(),
            this.updateSlidesClasses()
        }
        emitContainerClasses() {
            let e = this;
            if (!e.params._emitClasses || !e.el)
                return;
            let t = e.el.className.split(" ").filter(t => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
            e.emit("_containerClasses", t.join(" "))
        }
        getSlideClasses(e) {
            let t = this;
            return t.destroyed ? "" : e.className.split(" ").filter(e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass)).join(" ")
        }
        emitSlidesClasses() {
            let e = this;
            if (!e.params._emitClasses || !e.el)
                return;
            let t = [];
            e.slides.forEach(i => {
                let s = e.getSlideClasses(i);
                t.push({
                    slideEl: i,
                    classNames: s
                }),
                e.emit("_slideClass", i, s)
            }
            ),
            e.emit("_slideClasses", t)
        }
        slidesPerViewDynamic(e, t) {
            void 0 === e && (e = "current"),
            void 0 === t && (t = !1);
            let {params: i, slides: s, slidesGrid: l, slidesSizesGrid: r, size: n, activeIndex: a} = this
              , o = 1;
            if ("number" == typeof i.slidesPerView)
                return i.slidesPerView;
            if (i.centeredSlides) {
                let e, t = s[a] ? Math.ceil(s[a].swiperSlideSize) : 0;
                for (let i = a + 1; i < s.length; i += 1)
                    s[i] && !e && (t += Math.ceil(s[i].swiperSlideSize),
                    o += 1,
                    t > n && (e = !0));
                for (let i = a - 1; i >= 0; i -= 1)
                    s[i] && !e && (t += s[i].swiperSlideSize,
                    o += 1,
                    t > n && (e = !0))
            } else if ("current" === e)
                for (let e = a + 1; e < s.length; e += 1) {
                    let i = t ? l[e] + r[e] - l[a] < n : l[e] - l[a] < n;
                    i && (o += 1)
                }
            else
                for (let e = a - 1; e >= 0; e -= 1) {
                    let t = l[a] - l[e] < n;
                    t && (o += 1)
                }
            return o
        }
        update() {
            let e = this;
            if (!e || e.destroyed)
                return;
            let {snapGrid: t, params: i} = e;
            i.breakpoints && e.setBreakpoint(),
            [...e.el.querySelectorAll('[loading="lazy"]')].forEach(t => {
                t.complete && F(e, t)
            }
            ),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            (("auto" === i.slidesPerView || i.slidesPerView > 1) && e.isEnd && !i.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || function() {
                let t = e.rtlTranslate ? -1 * e.translate : e.translate
                  , i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(i),
                e.updateActiveIndex(),
                e.updateSlidesClasses()
            }(),
            i.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update")
        }
        changeDirection(e, t) {
            void 0 === t && (t = !0);
            let i = this.params.direction;
            return e || (e = "horizontal" === i ? "vertical" : "horizontal"),
            e === i || "horizontal" !== e && "vertical" !== e || (this.el.classList.remove(`${this.params.containerModifierClass}${i}`),
            this.el.classList.add(`${this.params.containerModifierClass}${e}`),
            this.emitContainerClasses(),
            this.params.direction = e,
            this.slides.forEach(t => {
                "vertical" === e ? t.style.width = "" : t.style.height = ""
            }
            ),
            this.emit("changeDirection"),
            t && this.update()),
            this
        }
        changeLanguageDirection(e) {
            (!this.rtl || "rtl" !== e) && (this.rtl || "ltr" !== e) && (this.rtl = "rtl" === e,
            this.rtlTranslate = "horizontal" === this.params.direction && this.rtl,
            this.rtl ? (this.el.classList.add(`${this.params.containerModifierClass}rtl`),
            this.el.dir = "rtl") : (this.el.classList.remove(`${this.params.containerModifierClass}rtl`),
            this.el.dir = "ltr"),
            this.update())
        }
        mount(e) {
            let t = this;
            if (t.mounted)
                return !0;
            let i = e || t.params.el;
            if ("string" == typeof i && (i = document.querySelector(i)),
            !i)
                return !1;
            i.swiper = t,
            i.parentNode && i.parentNode.host && i.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
            let s = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`
              , l = ( () => {
                if (i && i.shadowRoot && i.shadowRoot.querySelector) {
                    let e = i.shadowRoot.querySelector(s());
                    return e
                }
                return x(i, s())[0]
            }
            )();
            !l && t.params.createElements && (l = I("div", t.params.wrapperClass),
            i.append(l),
            x(i, `.${t.params.slideClass}`).forEach(e => {
                l.append(e)
            }
            ));
            let r = t.params.rtl ?? ("rtl" === i.dir.toLowerCase() || "rtl" === C(i, "direction"))
              , n = !!l && "-webkit-box" === C(l, "display");
            return Object.assign(t, {
                el: i,
                wrapperEl: l,
                slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : l,
                hostEl: t.isElement ? i.parentNode.host : i,
                mounted: !0,
                rtl: r,
                rtlTranslate: "horizontal" === t.params.direction && r,
                wrongRTL: n
            }),
            !0
        }
        syncSneakPeekCenter(e) {
            let {speed: t=0} = void 0 === e ? {} : e
              , i = this;
            requestAnimationFrame( () => {
                let e = i.slides;
                if (i.params?.isSneakPeekCenter && e.length > 1) {
                    let s = 0 === i.activeIndex
                      , l = i.activeIndex === e.length - 1 || i.isEnd
                      , r = Math.abs(i.snapGrid[1] - i.snapGrid[0])
                      , n = structuredClone(i.snapGrid[1]);
                    if (s) {
                        let s = e.at(-1);
                        s.swiperLoopMoveDOM = !0,
                        i.slidesEl.prepend(s),
                        s.swiperLoopMoveDOM = !1,
                        i.setTransition(0),
                        i.setTranslate(-(n + r)),
                        i.recalcSlides(),
                        i.updateSlides(),
                        i.setTransition(t),
                        i.setTranslate(-n)
                    } else if (l) {
                        let s = e[0];
                        s.swiperLoopMoveDOM = !0,
                        i.slidesEl.append(s),
                        s.swiperLoopMoveDOM = !1,
                        i.setTransition(0),
                        i.setTranslate(-(n - r)),
                        i.recalcSlides(),
                        i.updateSlides(),
                        i.setTransition(t),
                        i.setTranslate(-n)
                    }
                }
            }
            )
        }
        init(e) {
            let t = this;
            if (t.initialized)
                return t;
            let i = t.mount(e);
            if (!1 === i)
                return t;
            t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
            t.params.loop && t.loopCreate(void 0, !0),
            t.attachEvents();
            let s = [...t.el.querySelectorAll('[loading="lazy"]')];
            return t.isElement && s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
            s.forEach(e => {
                e.complete ? F(t, e) : e.addEventListener("load", e => F(t, e.target))
            }
            ),
            $(t),
            t.initialized = !0,
            t.emit("init"),
            t.emit("afterInit"),
            t
        }
        destroy(e, t) {
            void 0 === e && (e = !0),
            void 0 === t && (t = !0);
            let i = this
              , {params: s, el: l, wrapperEl: r, slides: n} = i;
            return void 0 === i.params || i.destroyed || (i.emit("beforeDestroy"),
            i.initialized = !1,
            i.__addedToDOM__ = !1,
            i.detachEvents(),
            s.loop && i.loopDestroy(),
            t && (i.removeClasses(),
            l && "string" != typeof l && l.removeAttribute("style"),
            r && r.removeAttribute("style"),
            n && n.length && n.forEach(e => {
                e.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass),
                e.removeAttribute("style"),
                e.removeAttribute("data-swiper-slide-index")
            }
            )),
            i.emit("destroy"),
            Object.keys(i.eventsListeners).forEach(e => {
                i.off(e)
            }
            ),
            !1 !== e && (i.el && "string" != typeof i.el && (i.el.swiper = null),
            function(e) {
                Object.keys(e).forEach(t => {
                    try {
                        e[t] = null
                    } catch (e) {}
                    try {
                        delete e[t]
                    } catch (e) {}
                }
                )
            }(i)),
            i.destroyed = !0,
            Z.instance && Z.instance.destroy()),
            null
        }
        static extendDefaults(e) {
            b(es, e)
        }
        static get extendedDefaults() {
            return es
        }
        static get defaults() {
            return et
        }
        static installModule(e) {
            el.prototype.__modules__ || (el.prototype.__modules__ = []);
            let t = el.prototype.__modules__;
            "function" == typeof e && 0 > t.indexOf(e) && t.push(e)
        }
        static use(e) {
            return Array.isArray(e) ? e.forEach(e => el.installModule(e)) : el.installModule(e),
            el
        }
    }
    function er(e, t, i, s) {
        return e.params.createElements && Object.keys(s).forEach(l => {
            if (!i[l] && !0 === i.auto) {
                let r = x(e.el, `.${s[l]}`)[0];
                r || ((r = I("div", s[l])).className = s[l],
                e.el.append(r)),
                i[l] = r,
                t[l] = r
            }
        }
        ),
        i
    }
    function en(e) {
        let {swiper: t, extendParams: i, on: s, emit: l} = e;
        function r(e) {
            let i;
            return e && "string" == typeof e && t.isElement && (i = t.el.querySelector(e) || t.hostEl.querySelector(e)) ? i : (e && ("string" == typeof e && (i = [...document.querySelectorAll(e)]),
            t.params.uniqueNavElements && "string" == typeof e && i && i.length > 1 && 1 === t.el.querySelectorAll(e).length ? i = t.el.querySelector(e) : i && 1 === i.length && (i = i[0])),
            e && !i) ? e : i
        }
        function n(e, i) {
            let s = t.params.navigation;
            (e = L(e)).forEach(e => {
                e && (e.classList[i ? "add" : "remove"](...s.disabledClass.split(" ")),
                "BUTTON" === e.tagName && (e.disabled = i),
                t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](s.lockClass))
            }
            )
        }
        function a() {
            let {nextEl: e, prevEl: i} = t.navigation;
            if (t.params.loop) {
                n(i, !1),
                n(e, !1);
                return
            }
            n(i, t.isBeginning && !t.params.rewind),
            n(e, t.isEnd && !t.params.rewind)
        }
        function o(e) {
            e.preventDefault(),
            (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(),
            l("navigationPrev"))
        }
        function d(e) {
            e.preventDefault(),
            (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(),
            l("navigationNext"))
        }
        function h() {
            let e = t.params.navigation;
            if (t.params.navigation = er(t, t.originalParams.navigation, t.params.navigation, {
                nextEl: "swiper-button-next",
                prevEl: "swiper-button-prev"
            }),
            !(e.nextEl || e.prevEl))
                return;
            let i = r(e.nextEl)
              , s = r(e.prevEl);
            Object.assign(t.navigation, {
                nextEl: i,
                prevEl: s
            }),
            i = L(i),
            s = L(s);
            let l = (i, s) => {
                i && i.addEventListener("click", "next" === s ? d : o),
                !t.enabled && i && i.classList.add(...e.lockClass.split(" "))
            }
            ;
            i.forEach(e => l(e, "next")),
            s.forEach(e => l(e, "prev"))
        }
        function p() {
            let {nextEl: e, prevEl: i} = t.navigation;
            e = L(e),
            i = L(i);
            let s = (e, i) => {
                e.removeEventListener("click", "next" === i ? d : o),
                e.classList.remove(...t.params.navigation.disabledClass.split(" "))
            }
            ;
            e.forEach(e => s(e, "next")),
            i.forEach(e => s(e, "prev"))
        }
        i({
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "swiper-button-disabled",
                hiddenClass: "swiper-button-hidden",
                lockClass: "swiper-button-lock",
                navigationDisabledClass: "swiper-navigation-disabled"
            }
        }),
        t.navigation = {
            nextEl: null,
            prevEl: null
        },
        s("init", () => {
            !1 === t.params.navigation.enabled ? u() : (h(),
            a())
        }
        ),
        s("toEdge fromEdge lock unlock", () => {
            a()
        }
        ),
        s("destroy", () => {
            p()
        }
        ),
        s("enable disable", () => {
            let {nextEl: e, prevEl: i} = t.navigation;
            if (e = L(e),
            i = L(i),
            t.enabled) {
                a();
                return
            }
            [...e, ...i].filter(e => !!e).forEach(e => e.classList.add(t.params.navigation.lockClass))
        }
        ),
        s("click", (e, i) => {
            let {nextEl: s, prevEl: r} = t.navigation;
            s = L(s),
            r = L(r);
            let n = i.target
              , a = r.includes(n) || s.includes(n);
            if (t.isElement && !a) {
                let e = i.path || i.composedPath && i.composedPath();
                e && (a = e.find(e => s.includes(e) || r.includes(e)))
            }
            if (t.params.navigation.hideOnClick && !a) {
                let e;
                if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === n || t.pagination.el.contains(n)))
                    return;
                s.length ? e = s[0].classList.contains(t.params.navigation.hiddenClass) : r.length && (e = r[0].classList.contains(t.params.navigation.hiddenClass)),
                !0 === e ? l("navigationShow") : l("navigationHide"),
                [...s, ...r].filter(e => !!e).forEach(e => e.classList.toggle(t.params.navigation.hiddenClass))
            }
        }
        );
        let u = () => {
            t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")),
            p()
        }
        ;
        Object.assign(t.navigation, {
            enable: () => {
                t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")),
                h(),
                a()
            }
            ,
            disable: u,
            update: a,
            init: h,
            destroy: p
        })
    }
    function ea(e) {
        return void 0 === e && (e = ""),
        `.${e.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`
    }
    function eo(e) {
        let t, {swiper: i, extendParams: s, on: l, emit: r} = e, n = "swiper-pagination";
        s({
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: e => e,
                formatFractionTotal: e => e,
                bulletClass: `${n}-bullet`,
                bulletActiveClass: `${n}-bullet-active`,
                modifierClass: `${n}-`,
                currentClass: `${n}-current`,
                totalClass: `${n}-total`,
                hiddenClass: `${n}-hidden`,
                progressbarFillClass: `${n}-progressbar-fill`,
                progressbarOppositeClass: `${n}-progressbar-opposite`,
                clickableClass: `${n}-clickable`,
                lockClass: `${n}-lock`,
                horizontalClass: `${n}-horizontal`,
                verticalClass: `${n}-vertical`,
                paginationDisabledClass: `${n}-disabled`
            }
        }),
        i.pagination = {
            el: null,
            bullets: []
        };
        let a = 0;
        function o() {
            return !i.params.pagination.el || !i.pagination.el || Array.isArray(i.pagination.el) && 0 === i.pagination.el.length
        }
        function d(e, t) {
            let {bulletActiveClass: s} = i.params.pagination;
            e && (e = e[`${"prev" === t ? "previous" : "next"}ElementSibling`]) && (e.classList.add(`${s}-${t}`),
            (e = e[`${"prev" === t ? "previous" : "next"}ElementSibling`]) && e.classList.add(`${s}-${t}-${t}`))
        }
        function h(e) {
            let t = e.target.closest(ea(i.params.pagination.bulletClass));
            if (!t)
                return;
            e.preventDefault();
            let s = k(t) * i.params.slidesPerGroup;
            if (i.params.loop) {
                let e = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(i.params.slidesPerView, 10));
                if (i.slides.length < e) {
                    i.slideTo(s);
                    return
                }
                if (i.realIndex === s)
                    return;
                s === i.realIndex + 1 || 0 === s && i.realIndex === i.slides.length - 1 ? i.slideNext() : (s === i.realIndex - 1 || s === i.slides.length - 1 && 0 === i.realIndex) && i.slidePrev(),
                i.params.isSneakPeekCenter ? i.slideToLoopCenterSneakPeek(s) : i.slideToLoop(s)
            } else
                i.slideTo(s)
        }
        function p() {
            let e, s;
            let l = i.rtl
              , n = i.params.pagination;
            if (o())
                return;
            let h = i.pagination.el;
            h = L(h);
            let p = i.virtual && i.params.virtual.enabled ? i.virtual.slides.length : i.slides.length
              , u = i.params.loop ? Math.ceil(p / i.params.slidesPerGroup) : i.snapGrid.length;
            if (i.params.loop ? (s = i.previousRealIndex || 0,
            e = i.params.slidesPerGroup > 1 ? Math.floor(i.realIndex / i.params.slidesPerGroup) : i.realIndex) : void 0 !== i.snapIndex ? (e = i.snapIndex,
            s = i.previousSnapIndex) : (s = i.previousIndex || 0,
            e = i.activeIndex || 0),
            "bullets" === n.type && i.pagination.bullets && i.pagination.bullets.length > 0) {
                let r, o, p;
                let u = i.pagination.bullets;
                if (n.dynamicBullets && (t = M(u[0], i.isHorizontal() ? "width" : "height"),
                h.forEach(e => {
                    e.style[i.isHorizontal() ? "width" : "height"] = `${t * (n.dynamicMainBullets + 4)}px`
                }
                ),
                n.dynamicMainBullets > 1 && void 0 !== s && ((a += e - (s || 0)) > n.dynamicMainBullets - 1 ? a = n.dynamicMainBullets - 1 : a < 0 && (a = 0)),
                p = ((o = (r = Math.max(e - a, 0)) + (Math.min(u.length, n.dynamicMainBullets) - 1)) + r) / 2),
                u.forEach(e => {
                    let t = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(e => `${n.bulletActiveClass}${e}`)].map(e => "string" == typeof e && e.includes(" ") ? e.split(" ") : e).flat();
                    e.classList.remove(...t)
                }
                ),
                h.length > 1)
                    u.forEach(t => {
                        let s = k(t);
                        s === e ? t.classList.add(...n.bulletActiveClass.split(" ")) : i.isElement && t.setAttribute("part", "bullet"),
                        n.dynamicBullets && (s >= r && s <= o && t.classList.add(...`${n.bulletActiveClass}-main`.split(" ")),
                        s === r && d(t, "prev"),
                        s === o && d(t, "next"))
                    }
                    );
                else {
                    let t = u[e];
                    if (t && t.classList.add(...n.bulletActiveClass.split(" ")),
                    i.isElement && u.forEach( (t, i) => {
                        t.setAttribute("part", i === e ? "bullet-active" : "bullet")
                    }
                    ),
                    n.dynamicBullets) {
                        let e = u[r]
                          , t = u[o];
                        for (let e = r; e <= o; e += 1)
                            u[e] && u[e].classList.add(...`${n.bulletActiveClass}-main`.split(" "));
                        d(e, "prev"),
                        d(t, "next")
                    }
                }
                if (n.dynamicBullets) {
                    let e = Math.min(u.length, n.dynamicMainBullets + 4)
                      , s = (t * e - t) / 2 - p * t
                      , r = l ? "right" : "left";
                    u.forEach(e => {
                        e.style[i.isHorizontal() ? r : "top"] = `${s}px`
                    }
                    )
                }
            }
            h.forEach( (t, s) => {
                if ("fraction" === n.type && (t.querySelectorAll(ea(n.currentClass)).forEach(t => {
                    t.textContent = n.formatFractionCurrent(e + 1)
                }
                ),
                t.querySelectorAll(ea(n.totalClass)).forEach(e => {
                    e.textContent = n.formatFractionTotal(u)
                }
                )),
                "progressbar" === n.type) {
                    let s;
                    s = n.progressbarOpposite ? i.isHorizontal() ? "vertical" : "horizontal" : i.isHorizontal() ? "horizontal" : "vertical";
                    let l = (e + 1) / u
                      , r = 1
                      , a = 1;
                    "horizontal" === s ? r = l : a = l,
                    t.querySelectorAll(ea(n.progressbarFillClass)).forEach(e => {
                        e.style.transform = `translate3d(0,0,0) scaleX(${r}) scaleY(${a})`,
                        e.style.transitionDuration = `${i.params.speed}ms`
                    }
                    )
                }
                "custom" === n.type && n.renderCustom ? (D(t, n.renderCustom(i, e + 1, u)),
                0 === s && r("paginationRender", t)) : (0 === s && r("paginationRender", t),
                r("paginationUpdate", t)),
                i.params.watchOverflow && i.enabled && t.classList[i.isLocked ? "add" : "remove"](n.lockClass)
            }
            )
        }
        function u() {
            let e = i.params.pagination;
            if (o())
                return;
            let t = i.virtual && i.params.virtual.enabled ? i.virtual.slides.length : i.grid && i.params.grid.rows > 1 ? i.slides.length / Math.ceil(i.params.grid.rows) : i.slides.length
              , s = i.pagination.el;
            s = L(s);
            let l = "";
            if ("bullets" === e.type) {
                let s = i.params.loop ? Math.ceil(t / i.params.slidesPerGroup) : i.snapGrid.length;
                i.params.freeMode && i.params.freeMode.enabled && s > t && (s = t);
                for (let t = 0; t < s; t += 1)
                    e.renderBullet ? l += e.renderBullet.call(i, t, e.bulletClass) : l += `<${e.bulletElement} ${i.isElement ? 'part="bullet"' : ""} class="${e.bulletClass}"></${e.bulletElement}>`
            }
            "fraction" === e.type && (l = e.renderFraction ? e.renderFraction.call(i, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
            "progressbar" === e.type && (l = e.renderProgressbar ? e.renderProgressbar.call(i, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`),
            i.pagination.bullets = [],
            s.forEach(t => {
                "custom" !== e.type && D(t, l || ""),
                "bullets" === e.type && i.pagination.bullets.push(...t.querySelectorAll(ea(e.bulletClass)))
            }
            ),
            "custom" !== e.type && r("paginationRender", s[0])
        }
        function c() {
            let e;
            i.params.pagination = er(i, i.originalParams.pagination, i.params.pagination, {
                el: "swiper-pagination"
            });
            let t = i.params.pagination;
            t.el && ("string" == typeof t.el && i.isElement && (e = i.el.querySelector(t.el)),
            e || "string" != typeof t.el || (e = [...document.querySelectorAll(t.el)]),
            e || (e = t.el),
            e && 0 !== e.length && (i.params.uniqueNavElements && "string" == typeof t.el && Array.isArray(e) && e.length > 1 && (e = [...i.el.querySelectorAll(t.el)]).length > 1 && (e = e.find(e => P(e, ".swiper")[0] === i.el)),
            Array.isArray(e) && 1 === e.length && (e = e[0]),
            Object.assign(i.pagination, {
                el: e
            }),
            (e = L(e)).forEach(e => {
                "bullets" === t.type && t.clickable && e.classList.add(...(t.clickableClass || "").split(" ")),
                e.classList.add(t.modifierClass + t.type),
                e.classList.add(i.isHorizontal() ? t.horizontalClass : t.verticalClass),
                "bullets" === t.type && t.dynamicBullets && (e.classList.add(`${t.modifierClass}${t.type}-dynamic`),
                a = 0,
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                "progressbar" === t.type && t.progressbarOpposite && e.classList.add(t.progressbarOppositeClass),
                t.clickable && e.addEventListener("click", h),
                i.enabled || e.classList.add(t.lockClass)
            }
            )))
        }
        function v() {
            let e = i.params.pagination;
            if (o())
                return;
            let t = i.pagination.el;
            t && (t = L(t)).forEach(t => {
                t.classList.remove(e.hiddenClass),
                t.classList.remove(e.modifierClass + e.type),
                t.classList.remove(i.isHorizontal() ? e.horizontalClass : e.verticalClass),
                e.clickable && (t.classList.remove(...(e.clickableClass || "").split(" ")),
                t.removeEventListener("click", h))
            }
            ),
            i.pagination.bullets && i.pagination.bullets.forEach(t => t.classList.remove(...e.bulletActiveClass.split(" ")))
        }
        i.pagination.onBulletClick = h,
        l("changeDirection", () => {
            if (!i.pagination || !i.pagination.el)
                return;
            let e = i.params.pagination
              , {el: t} = i.pagination;
            (t = L(t)).forEach(t => {
                t.classList.remove(e.horizontalClass, e.verticalClass),
                t.classList.add(i.isHorizontal() ? e.horizontalClass : e.verticalClass)
            }
            )
        }
        ),
        l("init", () => {
            !1 === i.params.pagination.enabled ? m() : (c(),
            u(),
            p())
        }
        ),
        l("activeIndexChange", () => {
            void 0 === i.snapIndex && p()
        }
        ),
        l("snapIndexChange", () => {
            p()
        }
        ),
        l("snapGridLengthChange", () => {
            u(),
            p()
        }
        ),
        l("destroy", () => {
            v()
        }
        ),
        l("enable disable", () => {
            let {el: e} = i.pagination;
            e && (e = L(e)).forEach(e => e.classList[i.enabled ? "remove" : "add"](i.params.pagination.lockClass))
        }
        ),
        l("lock unlock", () => {
            p()
        }
        ),
        l("click", (e, t) => {
            let s = t.target
              , l = L(i.pagination.el);
            if (i.params.pagination.el && i.params.pagination.hideOnClick && l && l.length > 0 && !s.classList.contains(i.params.pagination.bulletClass)) {
                if (i.navigation && (i.navigation.nextEl && s === i.navigation.nextEl || i.navigation.prevEl && s === i.navigation.prevEl))
                    return;
                let e = l[0].classList.contains(i.params.pagination.hiddenClass);
                !0 === e ? r("paginationShow") : r("paginationHide"),
                l.forEach(e => e.classList.toggle(i.params.pagination.hiddenClass))
            }
        }
        );
        let m = () => {
            i.el.classList.add(i.params.pagination.paginationDisabledClass);
            let {el: e} = i.pagination;
            e && (e = L(e)).forEach(e => e.classList.add(i.params.pagination.paginationDisabledClass)),
            v()
        }
        ;
        Object.assign(i.pagination, {
            enable: () => {
                i.el.classList.remove(i.params.pagination.paginationDisabledClass);
                let {el: e} = i.pagination;
                e && (e = L(e)).forEach(e => e.classList.remove(i.params.pagination.paginationDisabledClass)),
                c(),
                u(),
                p()
            }
            ,
            disable: m,
            render: u,
            update: p,
            init: c,
            destroy: v
        })
    }
    function ed(e) {
        let t, i, s, l, r, n, a, o, d, h, {swiper: p, extendParams: u, on: v, emit: m, params: g} = e;
        p.autoplay = {
            running: !1,
            paused: !1,
            timeLeft: 0
        },
        u({
            autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !1,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1
            }
        });
        let f = g && g.autoplay ? g.autoplay.delay : 3e3
          , w = g && g.autoplay ? g.autoplay.delay : 3e3
          , S = new Date().getTime();
        function b(e) {
            p && !p.destroyed && p.wrapperEl && e.target === p.wrapperEl && (p.wrapperEl.removeEventListener("transitionend", b),
            !h && (!e.detail || !e.detail.bySwiperTouchMove) && k())
        }
        let y = () => {
            if (p.destroyed || !p.autoplay.running)
                return;
            p.autoplay.paused ? l = !0 : l && (w = s,
            l = !1);
            let e = p.autoplay.paused ? s : S + w - new Date().getTime();
            p.autoplay.timeLeft = e,
            m("autoplayTimeLeft", e, e / f),
            i = requestAnimationFrame( () => {
                y()
            }
            )
        }
          , T = () => {
            let e;
            if (!(e = p.virtual && p.params.virtual.enabled ? p.slides.find(e => e.classList.contains("swiper-slide-active")) : p.slides[p.activeIndex]))
                return;
            let t = parseInt(e.getAttribute("data-swiper-autoplay"), 10);
            return t
        }
          , x = e => {
            if (p.destroyed || !p.autoplay.running)
                return;
            cancelAnimationFrame(i),
            y();
            let l = void 0 === e ? p.params.autoplay.delay : e;
            f = p.params.autoplay.delay,
            w = p.params.autoplay.delay;
            let r = T();
            !Number.isNaN(r) && r > 0 && void 0 === e && (l = r,
            f = r,
            w = r),
            s = l;
            let n = p.params.speed
              , a = () => {
                p && !p.destroyed && (p.params.autoplay.reverseDirection ? !p.isBeginning || p.params.loop || p.params.rewind ? (p.slidePrev(n, !0, !0),
                m("autoplay")) : p.params.autoplay.stopOnLastSlide || (p.slideTo(p.slides.length - 1, n, !0, !0),
                m("autoplay")) : !p.isEnd || p.params.loop || p.params.rewind ? (p.slideNext(n, !0, !0),
                m("autoplay")) : p.params.autoplay.stopOnLastSlide || (p.slideTo(0, n, !0, !0),
                m("autoplay")),
                p.params.cssMode && (S = new Date().getTime(),
                requestAnimationFrame( () => {
                    x()
                }
                )))
            }
            ;
            return l > 0 ? (clearTimeout(t),
            t = setTimeout( () => {
                a()
            }
            , l)) : requestAnimationFrame( () => {
                a()
            }
            ),
            l
        }
          , E = () => {
            S = new Date().getTime(),
            p.autoplay.running = !0,
            x(),
            m("autoplayStart")
        }
          , I = () => {
            p.autoplay.running = !1,
            clearTimeout(t),
            cancelAnimationFrame(i),
            m("autoplayStop")
        }
          , C = (e, i) => {
            if (p.destroyed || !p.autoplay.running)
                return;
            clearTimeout(t),
            e || (d = !0);
            let l = () => {
                m("autoplayPause"),
                p.params.autoplay.waitForTransition ? p.wrapperEl.addEventListener("transitionend", b) : k()
            }
            ;
            if (p.autoplay.paused = !0,
            i) {
                o && (s = p.params.autoplay.delay),
                o = !1,
                l();
                return
            }
            let r = s || p.params.autoplay.delay;
            s = r - (new Date().getTime() - S),
            p.isEnd && s < 0 && !p.params.loop || (s < 0 && (s = 0),
            l())
        }
          , k = () => {
            p.isEnd && s < 0 && !p.params.loop || p.destroyed || !p.autoplay.running || (S = new Date().getTime(),
            d ? (d = !1,
            x(s)) : x(),
            p.autoplay.paused = !1,
            m("autoplayResume"))
        }
          , P = () => {
            if (p.destroyed || !p.autoplay.running)
                return;
            let e = c();
            "hidden" === e.visibilityState && (d = !0,
            C(!0)),
            "visible" === e.visibilityState && k()
        }
          , M = e => {
            "mouse" === e.pointerType && (d = !0,
            h = !0,
            p.animating || p.autoplay.paused || C(!0))
        }
          , L = e => {
            "mouse" === e.pointerType && (h = !1,
            p.autoplay.paused && k())
        }
          , D = () => {
            p.params.autoplay.pauseOnMouseEnter && (p.el.addEventListener("pointerenter", M),
            p.el.addEventListener("pointerleave", L))
        }
          , A = () => {
            p.el && "string" != typeof p.el && (p.el.removeEventListener("pointerenter", M),
            p.el.removeEventListener("pointerleave", L))
        }
          , O = () => {
            let e = c();
            e.addEventListener("visibilitychange", P)
        }
          , z = () => {
            let e = c();
            e.removeEventListener("visibilitychange", P)
        }
        ;
        v("init", () => {
            p.params.autoplay.enabled && (D(),
            O(),
            E())
        }
        ),
        v("destroy", () => {
            A(),
            z(),
            p.autoplay.running && I()
        }
        ),
        v("_freeModeStaticRelease", () => {
            (n || d) && k()
        }
        ),
        v("_freeModeNoMomentumRelease", () => {
            p.params.autoplay.disableOnInteraction ? I() : C(!0, !0)
        }
        ),
        v("beforeTransitionStart", (e, t, i) => {
            !p.destroyed && p.autoplay.running && (i || !p.params.autoplay.disableOnInteraction ? C(!0, !0) : I())
        }
        ),
        v("sliderFirstMove", () => {
            if (!p.destroyed && p.autoplay.running) {
                if (p.params.autoplay.disableOnInteraction) {
                    I();
                    return
                }
                r = !0,
                n = !1,
                d = !1,
                a = setTimeout( () => {
                    d = !0,
                    n = !0,
                    C(!0)
                }
                , 200)
            }
        }
        ),
        v("touchEnd", () => {
            if (!p.destroyed && p.autoplay.running && r) {
                if (clearTimeout(a),
                clearTimeout(t),
                p.params.autoplay.disableOnInteraction) {
                    n = !1,
                    r = !1;
                    return
                }
                n && p.params.cssMode && k(),
                n = !1,
                r = !1
            }
        }
        ),
        v("slideChange", () => {
            !p.destroyed && p.autoplay.running && (o = !0)
        }
        ),
        Object.assign(p.autoplay, {
            start: E,
            stop: I,
            pause: C,
            resume: k
        })
    }
    function eh(e) {
        let {swiper: t, extendParams: i, on: s} = e;
        i({
            thumbs: {
                swiper: null,
                multipleActiveThumbs: !0,
                autoScrollOffset: 0,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-thumbs"
            }
        });
        let l = !1
          , r = !1;
        function n() {
            let e;
            let i = t.thumbs.swiper;
            if (!i || i.destroyed)
                return;
            let s = i.clickedIndex
              , l = i.clickedSlide;
            l && l.classList.contains(t.params.thumbs.slideThumbActiveClass) || null == s || (e = i.params.loop ? parseInt(i.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : s,
            t.params.loop ? t.slideToLoop(e) : t.slideTo(e))
        }
        function a() {
            let {thumbs: e} = t.params;
            if (l)
                return !1;
            l = !0;
            let i = t.constructor;
            if (e.swiper instanceof i) {
                if (e.swiper.destroyed)
                    return l = !1,
                    !1;
                t.thumbs.swiper = e.swiper,
                Object.assign(t.thumbs.swiper.originalParams, {
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1
                }),
                Object.assign(t.thumbs.swiper.params, {
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1
                }),
                t.thumbs.swiper.update()
            } else if (S(e.swiper)) {
                let s = Object.assign({}, e.swiper);
                Object.assign(s, {
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1
                }),
                t.thumbs.swiper = new i(s),
                r = !0
            }
            return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),
            t.thumbs.swiper.on("tap", n),
            !0
        }
        function o(e) {
            let i = t.thumbs.swiper;
            if (!i || i.destroyed)
                return;
            let s = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView
              , l = 1
              , r = t.params.thumbs.slideThumbActiveClass;
            if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (l = t.params.slidesPerView),
            t.params.thumbs.multipleActiveThumbs || (l = 1),
            l = Math.floor(l),
            i.slides.forEach(e => e.classList.remove(r)),
            i.params.loop || i.params.virtual && i.params.virtual.enabled)
                for (let e = 0; e < l; e += 1)
                    x(i.slidesEl, `[data-swiper-slide-index="${t.realIndex + e}"]`).forEach(e => {
                        e.classList.add(r)
                    }
                    );
            else
                for (let e = 0; e < l; e += 1)
                    i.slides[t.realIndex + e] && i.slides[t.realIndex + e].classList.add(r);
            let n = t.params.thumbs.autoScrollOffset
              , a = n && !i.params.loop;
            if (t.realIndex !== i.realIndex || a) {
                let l, r;
                let o = i.activeIndex;
                if (i.params.loop) {
                    let e = i.slides.find(e => e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`);
                    l = i.slides.indexOf(e),
                    r = t.activeIndex > t.previousIndex ? "next" : "prev"
                } else
                    r = (l = t.realIndex) > t.previousIndex ? "next" : "prev";
                a && (l += "next" === r ? n : -1 * n),
                i.visibleSlidesIndexes && 0 > i.visibleSlidesIndexes.indexOf(l) && (i.params.centeredSlides ? l = l > o ? l - Math.floor(s / 2) + 1 : l + Math.floor(s / 2) - 1 : l > o && i.params.slidesPerGroup,
                i.slideTo(l, e ? 0 : void 0))
            }
        }
        t.thumbs = {
            swiper: null
        },
        s("beforeInit", () => {
            let {thumbs: e} = t.params;
            if (e && e.swiper) {
                if ("string" == typeof e.swiper || e.swiper instanceof HTMLElement) {
                    let i = c()
                      , s = () => {
                        let s = "string" == typeof e.swiper ? i.querySelector(e.swiper) : e.swiper;
                        if (s && s.swiper)
                            e.swiper = s.swiper,
                            a(),
                            o(!0);
                        else if (s) {
                            let i = `${t.params.eventsPrefix}init`
                              , l = r => {
                                e.swiper = r.detail[0],
                                s.removeEventListener(i, l),
                                a(),
                                o(!0),
                                e.swiper.update(),
                                t.update()
                            }
                            ;
                            s.addEventListener(i, l)
                        }
                        return s
                    }
                      , l = () => {
                        if (t.destroyed)
                            return;
                        let e = s();
                        e || requestAnimationFrame(l)
                    }
                    ;
                    requestAnimationFrame(l)
                } else
                    a(),
                    o(!0)
            }
        }
        ),
        s("slideChange update resize observerUpdate", () => {
            o()
        }
        ),
        s("setTransition", (e, i) => {
            let s = t.thumbs.swiper;
            s && !s.destroyed && s.setTransition(i)
        }
        ),
        s("beforeDestroy", () => {
            let e = t.thumbs.swiper;
            e && !e.destroyed && r && e.destroy()
        }
        ),
        Object.assign(t.thumbs, {
            init: a,
            update: o
        })
    }
    Object.keys(ei).forEach(e => {
        Object.keys(ei[e]).forEach(t => {
            el.prototype[t] = ei[e][t]
        }
        )
    }
    ),
    el.use([function(e) {
        let {swiper: t, on: i, emit: s} = e
          , l = m()
          , r = null
          , n = null
          , a = () => {
            t && !t.destroyed && t.initialized && (s("beforeResize"),
            s("resize"))
        }
          , o = () => {
            t && !t.destroyed && t.initialized && (r = new ResizeObserver(e => {
                if (!t.__addedToDOM__) {
                    t.__addedToDOM__ = !0;
                    return
                }
                n = l.requestAnimationFrame( () => {
                    let {width: i, height: s} = t
                      , l = i
                      , r = s;
                    e.forEach(e => {
                        let {contentBoxSize: i, contentRect: s, target: n} = e;
                        n && n !== t.el || (l = s ? s.width : (i[0] || i).inlineSize,
                        r = s ? s.height : (i[0] || i).blockSize)
                    }
                    ),
                    (l !== i || r !== s) && a()
                }
                )
            }
            )).observe(t.el)
        }
          , d = () => {
            n && l.cancelAnimationFrame(n),
            r && r.unobserve && t.el && (r.unobserve(t.el),
            r = null)
        }
          , h = () => {
            t && !t.destroyed && t.initialized && s("orientationchange")
        }
        ;
        i("init", () => {
            if (t.params.resizeObserver && void 0 !== l.ResizeObserver) {
                o();
                return
            }
            l.addEventListener("resize", a),
            l.addEventListener("orientationchange", h)
        }
        ),
        i("destroy", () => {
            d(),
            l.removeEventListener("resize", a),
            l.removeEventListener("orientationchange", h)
        }
        )
    }
    , function(e) {
        let {swiper: t, extendParams: i, on: s, emit: l} = e
          , r = []
          , n = m()
          , a = function(e, i) {
            void 0 === i && (i = {});
            let s = n.MutationObserver || n.WebkitMutationObserver
              , a = new s(e => {
                if (t.__preventObserver__)
                    return;
                if (1 === e.length) {
                    l("observerUpdate", e[0]);
                    return
                }
                let i = function() {
                    l("observerUpdate", e[0])
                };
                n.requestAnimationFrame ? n.requestAnimationFrame(i) : n.setTimeout(i, 0)
            }
            );
            a.observe(e, {
                attributes: void 0 === i.attributes || i.attributes,
                childList: t.isElement || (void 0 === i.childList || i).childList,
                characterData: void 0 === i.characterData || i.characterData
            }),
            r.push(a)
        };
        i({
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        }),
        s("init", () => {
            if (t.params.observer) {
                if (t.params.observeParents) {
                    let e = P(t.hostEl);
                    for (let t = 0; t < e.length; t += 1)
                        a(e[t])
                }
                a(t.hostEl, {
                    childList: t.params.observeSlideChildren
                }),
                a(t.wrapperEl, {
                    attributes: !1
                })
            }
        }
        ),
        s("destroy", () => {
            r.forEach(e => {
                e.disconnect()
            }
            ),
            r.splice(0, r.length)
        }
        )
    }
    ]);
    let ep = "gp-feature-image-carousel"
      , eu = "initial-active-index";
    function ec(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i,
        e
    }
    let ev = "gp-carousel-"
      , em = "gp-carousel-dot"
      , eg = "gp-carousel-dot--active"
      , ef = "gem-slider-wrapper"
      , ew = "gem-slider-item"
      , eS = "var(--g-c-highlight, highlight)"
      , eb = "var(--g-c-bg-1, bg-1);";
    class ey extends GP.Component {
        static get observedAttributes() {
            return [eu]
        }
        attributeChangedCallback(e, t, i) {
            e !== eu || t || requestAnimationFrame( () => {
                requestAnimationFrame( () => {
                    var e;
                    null === (e = this.swiperInstance) || void 0 === e || e.slideTo(Number(i), 0)
                }
                )
            }
            )
        }
        getShouldInitByLayout() {
            var e;
            let t = this.getState("shouldInitByLayout");
            return !t || null === (e = n(t, window.screenSize.getDeviceName())) || void 0 === e || e
        }
        connectedCallback() {
            var e, t;
            this.gpsLazy = this.closest(".gps > section"),
            (null === (e = this.gpsLazy) || void 0 === e ? void 0 : e.classList.contains("gps-lazy")) ? null === (t = this.gpsLazy) || void 0 === t || t.addEventListener("GpLazyLoaded", this.handleGpLazyLoaded) : this.isLoaded = !0,
            this.getShouldInitByLayout() ? this.isReadyToInit = !0 : window.addEventListener("gp:debounceResize", this.checkLayoutToInit),
            this.init()
        }
        disconnectedCallback() {
            var e;
            window.removeEventListener("gp:debounceResize", this.checkLayoutToInit),
            null === (e = this.gpsLazy) || void 0 === e || e.removeEventListener("GpLazyLoaded", this.handleGpLazyLoaded),
            this.resizeObserver && (this.resizeObserver.disconnect(),
            this.resizeObserver = void 0),
            this.hostResizeObserver && (this.hostResizeObserver.disconnect(),
            this.hostResizeObserver = void 0),
            this.resizeTimeout && (clearTimeout(this.resizeTimeout),
            this.resizeTimeout = void 0),
            this.swiperTimeout && (clearTimeout(this.swiperTimeout),
            this.swiperTimeout = void 0),
            this.swiperInstance && (this.swiperInstance.destroy(!0, !1),
            this.swiperInstance = void 0)
        }
        setSlider(e) {
            this.swiperInstance = e
        }
        onCreatedSlider() {
            this.updateSwiperWrapperWidth(),
            this.getBackAndNextButton(),
            this.addEventNextAndBackSlide(),
            this.checkHideArrow(),
            this.getDotContainer(),
            this.initSliderEvent(),
            this.isShowingDotInCurrentDevice() && (this.checkHideDot(),
            this.updateDotColor(0))
        }
        watchSneakPeakCenter(e) {
            var t;
            let i = this.getIsSneakPeekCenter()
              , s = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, window.screenSize.getDeviceName(), !0);
            if (!i || s) {
                e.allowSlideNext = !0,
                e.allowSlidePrev = !0;
                return
            }
            let l = this.getDotItems().length;
            if (!l) {
                e.allowSlideNext = !0,
                e.allowSlidePrev = !0;
                return
            }
            let r = this.shouldSkipSlide ? 1 : 0
              , a = r + l - 1
              , o = this.shouldSkipSlide ? a + this.skipSlideCount - 1 : a
              , d = e.snapIndex >= o;
            if (e.isEnd = d,
            e.allowSlideNext = !d,
            this.shouldSkipSlide) {
                let t = e.snapIndex <= this.skipSlideCount;
                e.isBeginning = t,
                e.allowSlidePrev = !t
            } else
                e.allowSlidePrev = !0
        }
        onTouchStart(e) {
            var t;
            let i = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, window.screenSize.getDeviceName(), !0);
            this.getIsSneakPeekCenter() && !i && (e.allowSlideNext = !0,
            e.allowSlidePrev = !0)
        }
        restoreSneakPeekBoundary(e) {
            var t;
            let i = this.getIsSneakPeekCenter()
              , s = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, window.screenSize.getDeviceName(), !0);
            if (!i || s)
                return;
            let l = this.getDotItems().length;
            if (!l)
                return;
            let r = this.shouldSkipSlide ? 1 : 0
              , a = r + l - 1
              , o = this.shouldSkipSlide ? a + this.skipSlideCount - 1 : a
              , d = t => e.rtlTranslate ? e.snapGrid[t] : -e.snapGrid[t]
              , h = e.translate
              , p = d(o);
            if (Number.isFinite(p)) {
                let t = e.rtlTranslate ? h > p : h < p;
                t && (e.allowSlideNext = !0,
                e.slideTo(o, 0, !1))
            }
            if (this.shouldSkipSlide) {
                let t = d(r);
                if (Number.isFinite(t)) {
                    let i = e.rtlTranslate ? h < t : h > t;
                    i && (e.allowSlidePrev = !0,
                    e.slideTo(r, 0, !1))
                }
            }
        }
        onTouchEnd(e) {
            this.restoreSneakPeekBoundary(e),
            this.watchSneakPeakCenter(e)
        }
        onSlideChange(e) {
            this.setSlider(e),
            this.updateSwiperWrapperWidth(e),
            this.setAttribute("active-index", e.realIndex + "");
            let t = new Event("changeActiveIndex");
            this.dispatchEvent(t),
            this.watchSneakPeakCenter(e)
        }
        onTransitionEnd(e) {
            var t, i, s;
            let l = e.realIndex
              , r = window.screenSize.getDeviceName()
              , a = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, r, !0)
              , o = n(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, r, !1)
              , d = n(null === (s = this.setting) || void 0 === s ? void 0 : s[this.slidesPerViewSettingKey], r, 1)
              , h = this.isDuplicatedSlides && l >= this.totalItems
              , p = o || a
              , u = l;
            p && h ? u = l - this.totalItems : p || (u = Math.ceil(l / d)),
            this.shouldSkipSlide && (u = Math.max(0, l - this.skipSlideCount));
            let c = this.getForwardSneakPeekDotIndex(e);
            void 0 !== c && (u = c),
            this.updateDotColor(u),
            this.checkDisableArrowButton()
        }
        getSliderOption() {
            var e, t, i, s, a, o, d, h, p, u, c, v;
            let m = this.getSlideToShow()
              , g = window.screenSize.getDeviceName()
              , f = n(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, g, !0)
              , w = e => this.carouselType === r.FEATURE_IMAGE ? 1 : this.carouselType === r.FEATURE_IMAGE_THUMBS ? "auto" : n(m, e, 4) || 1
              , S = e => {
                var t, i;
                return n(null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeak, e, !1) && "center" === n(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeakType, e)
            }
              , b = e => {
                var t, i, s, l;
                let r = S(e)
                  , a = n(null === (t = this.setting) || void 0 === t ? void 0 : t.itemNumber, e)
                  , o = w(e)
                  , d = n(null === (i = this.setting) || void 0 === i ? void 0 : i.enableDrag, e, !1)
                  , h = this.calculateSlidesOffset({
                    slidesPerView: o,
                    itemNumberByDevice: a,
                    centeredSlides: r
                })
                  , p = {
                    slidesPerView: o,
                    loop: n(null === (s = this.setting) || void 0 === s ? void 0 : s.loop, e, !0),
                    allowTouchMove: d,
                    spaceBetween: n(null === (l = this.styles) || void 0 === l ? void 0 : l.spacing, e) || 0,
                    slidesOffsetBefore: h,
                    slidesOffsetAfter: h,
                    centeredSlides: r
                };
                return p
            }
              , y = window.screenSize.isMobile() ? null !== (c = null !== (u = null == m ? void 0 : m.mobile) && void 0 !== u ? u : null == m ? void 0 : m.tablet) && void 0 !== c ? c : null == m ? void 0 : m.desktop : window.screenSize.isTablet() && null !== (v = null == m ? void 0 : m.tablet) && void 0 !== v ? v : null == m ? void 0 : m.desktop
              , T = "auto" === y || y > 0 ? {
                1025: b(l.DESKTOP),
                768: b(l.TABLET),
                0: b(l.MOBILE)
            } : {}
              , x = this.getIsSneakPeekCenter()
              , E = {
                speed: null !== (a = null === (t = this.styles) || void 0 === t ? void 0 : t.playSpeed) && void 0 !== a ? a : 500,
                watchSlidesProgress: !0,
                wrapperClass: ef,
                slideClass: ew,
                thumbs: {
                    slideThumbActiveClass: "gem-slider-item-active"
                },
                breakpoints: T,
                loopPreventsSliding: !1,
                slidesPerView: w(g),
                isSneakPeekCenter: x,
                ...this.shouldSkipSlide && {
                    initialSlide: this.skipSlideCount
                },
                rtl: null !== (o = null === (i = this.setting) || void 0 === i ? void 0 : i.rtl) && void 0 !== o && o,
                direction: this.getDirection(),
                on: {
                    init: () => this.onCreatedSlider(),
                    slideChange: e => this.onSlideChange(e),
                    resize: e => this.onResizeSlider(e),
                    transitionEnd: e => this.onTransitionEnd(e),
                    touchStart: e => this.onTouchStart(e),
                    touchEnd: e => this.onTouchEnd(e)
                }
            };
            return this.carouselType !== r.FEATURE_IMAGE && this.carouselType !== r.FEATURE_IMAGE_THUMBS && (null === (s = this.setting) || void 0 === s ? void 0 : s.autoplay) && (E.autoplay = {
                delay: (null !== (p = null === (d = this.setting) || void 0 === d ? void 0 : d.autoplayTimeout) && void 0 !== p ? p : 1) * 1e3,
                pauseOnMouseEnter: null === (h = this.setting) || void 0 === h ? void 0 : h.pauseOnHover,
                stopOnLastSlide: !f
            }),
            E
        }
        get slidesPerViewSettingKey() {
            return this.carouselType === r.PRODUCT_LIST ? "slidesToShow" : "itemNumber"
        }
        getSlidesPerViewDynamic() {
            var e, t, i, s;
            if (!this.swiperInstance || "auto" !== this.getSliderSetting().slidePerPage)
                return 1;
            let l = 1
              , {slides: r, slidesGrid: n, activeIndex: a} = this.swiperInstance
              , o = "horizontal" === this.getDirection() ? (null === (e = this.swiperInstance) || void 0 === e ? void 0 : e.width) || 0 : (null === (t = this.swiperInstance) || void 0 === t ? void 0 : t.height) || 0;
            for (let e = a + 1; e < r.length; e += 1) {
                let t = (null !== (i = n[e]) && void 0 !== i ? i : 0) - (null !== (s = n[a]) && void 0 !== s ? s : 0) < o;
                t && (l += 1)
            }
            return l
        }
        getIsSneakPeekCenter() {
            var e, t, i, s;
            let l = window.screenSize.getDeviceName();
            return n(null === (e = this.setting) || void 0 === e ? void 0 : e.sneakPeak, l, !1) && "center" === n(null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeakType, l) && "number" == typeof n(null === (i = this.setting) || void 0 === i ? void 0 : i.itemNumber, l) && Number(n(null === (s = this.setting) || void 0 === s ? void 0 : s.itemNumber, l)) > 1 && this.carouselType !== r.PRODUCT_LIST
        }
        computeShouldSkipSlideWhenSneakPeekCenter() {
            var e, t, i;
            if (this.skipSlideCount = 0,
            !this.getIsSneakPeekCenter())
                return !1;
            let s = window.screenSize.getDeviceName()
              , l = n(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, s, !0);
            if (l)
                return !1;
            let r = null !== (t = this.getNumberOfFullWidthShow(s)) && void 0 !== t ? t : 1;
            if (r < 2)
                return !1;
            let a = null !== (i = this.totalItems) && void 0 !== i ? i : 0;
            return r % 2 != 0 && a >= r + 2 && (this.skipSlideCount = Math.floor(r / 2),
            !0)
        }
        getDirection() {
            var e;
            let t = n(null === (e = this.setting) || void 0 === e ? void 0 : e.vertical, window.screenSize.getDeviceName()) ? "vertical" : "horizontal";
            return t
        }
        getSliderSetting() {
            let e = this.getSlideToShow();
            return {
                slidePerPage: this.getValueByDevice(e, window.screenSize.getDeviceName(), 4)
            }
        }
        getIndexSlideItemBy(e) {
            let t = this.getItemsPerPage()
              , i = this.totalItems
              , s = e * t;
            return s >= i - t && (s = i - t),
            s
        }
        shouldDuplicateSlides() {
            var e, t, i, s;
            let l = this.totalItems
              , r = window.screenSize.getDeviceName()
              , a = n(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, r, !0)
              , o = n(null === (t = this.setting) || void 0 === t ? void 0 : t[this.slidesPerViewSettingKey], r);
            if (!a || l < o)
                return !1;
            let d = Number.isNaN(Number(o)) ? this.getSlidesPerViewDynamic() : Math.ceil(Number(o))
              , h = n(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, r, !1)
              , p = h && "center" === n(null === (s = this.setting) || void 0 === s ? void 0 : s.sneakPeakType, r);
            p && d % 2 == 0 && (d += 1);
            let u = p ? Math.max(1, Math.ceil(d / 2)) : 1;
            return l < d + u
        }
        duplicateSlidesForLoop() {
            var e, t, i;
            if (this.isDuplicatedSlides)
                return;
            let s = this.shouldDuplicateSlides();
            if (!s || (this.isDuplicatedSlides = s,
            !this.sliderWrapper))
                return;
            let l = Array.from(null !== (i = null === (e = this.sliderWrapper) || void 0 === e ? void 0 : e.children) && void 0 !== i ? i : [])
              , r = document.createDocumentFragment();
            l.forEach(e => {
                let t = e.cloneNode(!0);
                t.setAttribute("data-duplicate", "true"),
                r.appendChild(t)
            }
            ),
            null === (t = this.sliderWrapper) || void 0 === t || t.appendChild(r)
        }
        handleDuplicateSlidesCleanup() {
            var e;
            let t = this.shouldDuplicateSlides();
            if (t || !this.isDuplicatedSlides || !this.sliderWrapper)
                return;
            let i = this.sliderWrapper.querySelectorAll('[data-duplicate="true"]');
            i.forEach(e => {
                e.remove()
            }
            ),
            this.isDuplicatedSlides = !1,
            null === (e = this.swiperInstance) || void 0 === e || e.update()
        }
        initResizeObserver() {
            this.resizeObserver && this.resizeObserver.disconnect(),
            this.resizeObserver = new ResizeObserver(e => {
                this.resizeTimeout && clearTimeout(this.resizeTimeout),
                this.isInitializing || (this.resizeTimeout = setTimeout( () => {
                    this.handleScreenResize()
                }
                , 300))
            }
            );
            let e = document.documentElement;
            e && this.resizeObserver.observe(e)
        }
        handleScreenResize() {
            this.isShowingDotInCurrentDevice() && (this.getDotContainer(),
            this.renderSliderDots())
        }
        onResizeSlider(e) {
            setTimeout( () => {
                this.updateSwiperWrapperWidth(e);
                let t = e.params.direction
                  , i = this.getDirection();
                t !== i && (e.changeDirection(i),
                this.setSlider(e))
            }
            , 10)
        }
        updateSwiperWrapperWidth(e) {
            var t, i, s, l;
            let r = null === this || void 0 === this ? void 0 : this.querySelector(`.${ef}`);
            if (!(null == r ? void 0 : r.style))
                return;
            let n = null != e ? e : this.swiperInstance
              , a = null !== (s = null === (t = null == n ? void 0 : n.el) || void 0 === t ? void 0 : t.clientWidth) && void 0 !== s ? s : 0
              , o = null !== (l = null === (i = r.parentElement) || void 0 === i ? void 0 : i.clientWidth) && void 0 !== l ? l : 0
              , d = this.clientWidth || this.offsetWidth || 0
              , h = (null == n ? void 0 : n.width) || a || o || d || 0;
            h && !(h <= 0) && r.style.setProperty("width", `${h}px`, "important")
        }
        observeHostForRecovery() {
            this.hostResizeObserver && this.hostResizeObserver.disconnect(),
            this.hostResizeObserver = new ResizeObserver( () => {
                let e = this.swiperInstance;
                !e || e.width > 0 || this.clientWidth <= 0 || (this.updateSwiperWrapperWidth(e),
                e.update())
            }
            ),
            this.hostResizeObserver.observe(this)
        }
        getDotContainer() {
            var e;
            this.dotContainer = null === (e = this.getElementsByClassName(`gp-carousel-dot-container-${this.componentId}`)) || void 0 === e ? void 0 : e[0]
        }
        isShowingDotInCurrentDevice() {
            var e, t, i, s;
            let r = null === (e = this.setting) || void 0 === e ? void 0 : e.dot
              , n = null === (t = this.setting) || void 0 === t ? void 0 : t.dotStyle;
            if (!r || !n)
                return !1;
            let a = window.screenSize.getDeviceName()
              , {desktop: o, tablet: d, mobile: h} = r
              , {desktop: p, tablet: u, mobile: c} = n;
            switch (a) {
            case l.DESKTOP:
                return !!o && "none" !== p;
            case l.TABLET:
                return !!(null != d ? d : o) && (null != u ? u : p) !== "none";
            case l.MOBILE:
                return !!(null !== (i = null != h ? h : d) && void 0 !== i ? i : o) && (null !== (s = null != c ? c : u) && void 0 !== s ? s : p) !== "none";
            default:
                return !1
            }
        }
        renderSliderDots(e) {
            var t;
            if (!this.isShowingDotInCurrentDevice())
                return;
            let i = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, window.screenSize.getDeviceName(), !0)
              , s = this.getDotItems();
            if (!this.dotContainer || 0 === s.length)
                return;
            let l = ""
              , r = this.getForwardSneakPeekDotIndex();
            s.forEach(t => {
                var s, n, a, o;
                let d;
                d = void 0 !== e ? e : this.shouldSkipSlide ? Math.max(0, (null !== (n = null === (s = this.swiperInstance) || void 0 === s ? void 0 : s.realIndex) && void 0 !== n ? n : this.skipSlideCount) - this.skipSlideCount) : void 0 !== r ? r : this.getActiveIndexDot(i, null !== (o = null === (a = this.swiperInstance) || void 0 === a ? void 0 : a.realIndex) && void 0 !== o ? o : 0, this.getItemsPerPage());
                let h = t === d;
                l += this.renderDot({
                    idx: t,
                    isActive: h
                })
            }
            ),
            this.dotContainer.innerHTML = l
        }
        renderDot(e) {
            var t, i, s;
            let {idx: l, isActive: r} = e
              , n = r ? null === (t = this.setting) || void 0 === t ? void 0 : t.dotActiveColor : null === (i = this.setting) || void 0 === i ? void 0 : i.dotColor
              , a = window.screenSize.getDeviceName();
            return `
      <button
        type="button"
        id="gp-dot-item-${this.componentId}-${l}"
        data-index="${l}"
        aria-label="dot"
        style="background-color: ${n ? d(this.getValueByDevice(n, a, void 0)) : r ? eS : eb};
        aspect-ratio: 1/1;
        width: ${this.getValueByDevice(null === (s = this.setting) || void 0 === s ? void 0 : s.dotSize, a, 12)}px;
        border-radius: 9999px;
        box-shadow: 0 4px 6px -1px rgba(0,0,0,.1);
        --tw-shadow: 0 2px 4px -2px rgba(0,0,0,.1);
        --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color);"
        class="${em} ${r ? `${eg} gem-slider-dot-active` : "gem-slider-dot-inactive"}"
      >
      </button>
    `
        }
        initSliderEvent() {
            this.addEventOptionsChange()
        }
        addEventOptionsChange() {
            this.updateDotClickEvent()
        }
        updateDotClickEvent() {
            this.dotContainer && this.dotContainer.addEventListener("click", e => {
                e.preventDefault();
                let t = e.target;
                !t.classList.contains(em) || t.classList.contains(eg) || this.goToSlideByIndex({
                    index: this.getSlideIndexByDot(t)
                })
            }
            )
        }
        getSlideIndexByDot(e) {
            var t;
            return (null === (t = e.dataset) || void 0 === t ? void 0 : t.index) ? parseInt(e.dataset.index, 10) : void 0
        }
        getForwardSneakPeekDotIndex(e) {
            var t, i, s, l;
            let r = window.screenSize.getDeviceName()
              , a = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, r, !0)
              , o = n(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, r, !1)
              , d = "center" === n(null === (s = this.setting) || void 0 === s ? void 0 : s.sneakPeakType, r);
            if (!a && o && !d)
                return null === (l = null != e ? e : this.swiperInstance) || void 0 === l ? void 0 : l.snapIndex
        }
        updateDotColor(e) {
            var t, i, s, l, r;
            if (isNaN(e))
                return;
            let n = Math.ceil(e)
              , a = null === (i = this.dotContainer) || void 0 === i ? void 0 : null === (t = i.getElementsByClassName(`${eg}`)) || void 0 === t ? void 0 : t[0];
            if (!a)
                return;
            let o = (null === (s = a.dataset) || void 0 === s ? void 0 : s.index) ? parseInt(null === (l = a.dataset) || void 0 === l ? void 0 : l.index, 10) : void 0;
            if (o === e)
                return;
            let {activeBgc: d, inactiveBgc: h} = this.getDotBackgroundColorFrom(a);
            a.style.backgroundColor = h || eb,
            a.classList.remove(eg);
            let p = null === (r = this.dotContainer) || void 0 === r ? void 0 : r.querySelector(`#gp-dot-item-${this.componentId}-${n}`);
            p && (p.style.backgroundColor = d || eS,
            p.classList.add(eg))
        }
        getDotBackgroundColorFrom(e) {
            let t = e.previousElementSibling
              , i = "";
            if (t)
                i = t.style.backgroundColor;
            else {
                var s;
                let t = e.nextElementSibling;
                i = (null == t ? void 0 : null === (s = t.style) || void 0 === s ? void 0 : s.backgroundColor) || ""
            }
            let l = e.style.backgroundColor;
            return {
                activeBgc: l,
                inactiveBgc: i
            }
        }
        getBackAndNextButton() {
            var e, t;
            this.nextButton = null === (e = this.getElementsByClassName(`gp-carousel-action-next ${this.componentId}`)) || void 0 === e ? void 0 : e[0],
            this.backButton = null === (t = this.getElementsByClassName(`gp-carousel-action-back ${this.componentId}`)) || void 0 === t ? void 0 : t[0]
        }
        addEventNextAndBackSlide() {
            var e, t;
            null === (e = this.nextButton) || void 0 === e || e.addEventListener("click", e => {
                var t;
                e.preventDefault(),
                null === (t = this.swiperInstance) || void 0 === t || t.slideNext()
            }
            ),
            null === (t = this.backButton) || void 0 === t || t.addEventListener("click", e => {
                var t;
                e.preventDefault(),
                null === (t = this.swiperInstance) || void 0 === t || t.slidePrev()
            }
            )
        }
        getIsHideNavigation() {
            var e, t, i, s, l, r;
            let a = n(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, window.screenSize.getDeviceName(), !0)
              , {slidePerPage: o} = this.getSliderSetting();
            if ("auto" === o) {
                let e = (null === (t = this.swiperInstance) || void 0 === t ? void 0 : t.slides.slice(0, this.totalItems)) || []
                  , n = Number((null === (s = this.swiperInstance) || void 0 === s ? void 0 : null === (i = s.params) || void 0 === i ? void 0 : i.spaceBetween) || 0)
                  , a = n * (e.length - 1)
                  , o = e.map(e => ({
                    width: e.offsetWidth,
                    height: e.offsetHeight
                }))
                  , d = o.reduce( (e, t) => e + t.width, 0) + a
                  , h = o.reduce( (e, t) => e + t.height, 0) + a
                  , p = e.length
                  , u = "horizontal" === this.getDirection() ? d - ((null === (l = this.swiperInstance) || void 0 === l ? void 0 : l.width) || 0) > p : h - ((null === (r = this.swiperInstance) || void 0 === r ? void 0 : r.height) || 0) > p;
                return !u
            }
            let d = a && o > this.totalItems || !a && o >= this.totalItems;
            return d
        }
        checkHideArrow() {
            var e, t, i, s, l;
            let r = this.getValueByDevice(null === (e = this.setting) || void 0 === e ? void 0 : e.navigationEnable, window.screenSize.getDeviceName(), !0);
            if (!r) {
                null === (s = this.backButton) || void 0 === s || s.style.setProperty("display", "none", "important"),
                null === (l = this.nextButton) || void 0 === l || l.style.setProperty("display", "none", "important");
                return
            }
            null === (t = this.backButton) || void 0 === t || t.style.setProperty("display", "flex", "important"),
            null === (i = this.nextButton) || void 0 === i || i.style.setProperty("display", "flex", "important");
            let n = this.getIsHideNavigation();
            if (n)
                return this.backButton && this.disableArrowButton(this.backButton),
                this.nextButton && this.disableArrowButton(this.nextButton),
                !0;
            this.backButton && this.enableArrowButton(this.backButton),
            this.nextButton && this.enableArrowButton(this.nextButton)
        }
        checkHideDot() {
            var e;
            let t = this.getIsHideNavigation();
            t && (null === (e = this.dotContainer) || void 0 === e || e.style.setProperty("display", "none", "important"))
        }
        checkDisableArrowButton() {
            var e, t, i, s, l;
            let r = window.screenSize.getDeviceName()
              , a = n(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, r, !0)
              , o = this.getIsHideNavigation();
            if (a && !o) {
                this.backButton && this.isDisableArrowButton(this.backButton) && this.enableArrowButton(this.backButton),
                this.nextButton && this.isDisableArrowButton(this.nextButton) && this.enableArrowButton(this.nextButton);
                return
            }
            if (a)
                return;
            let d = (null !== (l = null === (t = this.swiperInstance) || void 0 === t ? void 0 : t.slides.length) && void 0 !== l ? l : 0) - 1
              , h = this.getValueByDevice(null === (i = this.setting) || void 0 === i ? void 0 : i.navigationEnable, r, !0)
              , p = this.getValueByDevice(null === (s = this.setting) || void 0 === s ? void 0 : s.navigationStyle, r, "none");
            if ("none" !== p && h) {
                if (d === 1 / 0)
                    return;
                this.checkDisabledForBackButton(),
                this.checkDisabledForNextButton()
            }
        }
        checkDisabledForBackButton() {
            var e;
            if (this.backButton) {
                if (null === (e = this.swiperInstance) || void 0 === e ? void 0 : e.isBeginning) {
                    this.disableArrowButton(this.backButton);
                    return
                }
                this.enableArrowButton(this.backButton)
            }
        }
        checkDisabledForNextButton() {
            var e;
            this.nextButton && ((null === (e = this.swiperInstance) || void 0 === e ? void 0 : e.isEnd) ? this.disableArrowButton(this.nextButton) : this.enableArrowButton(this.nextButton))
        }
        isDisableArrowButton(e) {
            return (null == e ? void 0 : e.dataset.hidden) === "true" && "hidden" === e.style.visibility || "hidden" === e.style.getPropertyValue("--v")
        }
        disableArrowButton(e) {
            !1 !== this.isHiddenArrowWhenDisabled && (e.style.setProperty("visibility", "hidden", "important"),
            e.dataset.hidden = "true"),
            e.disabled = !0
        }
        enableArrowButton(e) {
            !1 !== this.isHiddenArrowWhenDisabled && (e.style.removeProperty("visibility"),
            e.style.removeProperty("--v"),
            e.dataset.hidden = "false"),
            e.disabled = !1
        }
        setGalleryThumbs() {
            this.carouselType === r.FEATURE_IMAGE && setTimeout( () => {
                var e, t, i;
                let s = this.closest("gp-product-images-v3");
                if (null == s ? void 0 : null === (e = s.shouldDisableGalleryThumbs) || void 0 === e ? void 0 : e.call(s))
                    return;
                let l = null === (t = this.parentElement) || void 0 === t ? void 0 : t.querySelector(".gallery-wrapper.gp-product-images-gallery .gp-carousel-wrapper .swiper-initialized");
                l && (null === (i = this.swiperInstance) || void 0 === i ? void 0 : i.thumbs) && (this.swiperInstance.thumbs.swiper = null == l ? void 0 : l.swiper,
                this.swiperInstance.thumbs.init(),
                this.swiperInstance.update())
            }
            , 10)
        }
        get activeIndex() {
            var e, t;
            return null !== (t = null === (e = this.swiperInstance) || void 0 === e ? void 0 : e.activeIndex) && void 0 !== t ? t : 0
        }
        slideTo(e, t=!1) {
            var i;
            null === (i = this.swiperInstance) || void 0 === i || i.slideTo(e, t ? 0 : void 0)
        }
        dispatchEventSelectItem(e) {
            this.trigger && (this.trigger({
                event: "gp:rollback:select-slide"
            }),
            this.trigger({
                event: "gp:select-slide",
                data: e
            }))
        }
        reQuerySlideItems() {
            this.slideItems = this.querySelectorAll(`#gp-carousel-${this.componentId} .${ew}-${this.componentId}:not([data-duplicate="true"])`)
        }
        reQuerySliderWrapper() {
            this.sliderWrapper = this.querySelector(`#gp-carousel-${this.componentId} .${ef}`)
        }
        reQueryAllSlideItems() {
            this.allSlideItems = this.querySelectorAll(`#gp-carousel-${this.componentId} .${ew}-${this.componentId}`)
        }
        getValueByDevice(e, t, i) {
            var s, r, n, a, o, d;
            let h = t || window.screenSize.getDeviceName();
            switch (h) {
            case l.MOBILE:
                return null !== (n = null !== (r = null !== (s = null == e ? void 0 : e.mobile) && void 0 !== s ? s : null == e ? void 0 : e.tablet) && void 0 !== r ? r : null == e ? void 0 : e.desktop) && void 0 !== n ? n : i;
            case l.TABLET:
                return null !== (o = null !== (a = null == e ? void 0 : e.tablet) && void 0 !== a ? a : null == e ? void 0 : e.desktop) && void 0 !== o ? o : i;
            default:
                return null !== (d = null == e ? void 0 : e.desktop) && void 0 !== d ? d : i
            }
        }
        constructor(...e) {
            super(...e),
            ec(this, "componentId", ""),
            ec(this, "isDuplicatedSlides", !1),
            ec(this, "totalItems", 0),
            ec(this, "filteredVisibleIndices", null),
            ec(this, "shouldSkipSlide", !1),
            ec(this, "skipSlideCount", 0),
            ec(this, "swiperInstance", void 0),
            ec(this, "setting", void 0),
            ec(this, "styles", void 0),
            ec(this, "dotContainer", void 0),
            ec(this, "nextButton", void 0),
            ec(this, "backButton", void 0),
            ec(this, "isHiddenArrowWhenDisabled", void 0),
            ec(this, "resizeObserver", void 0),
            ec(this, "hostResizeObserver", void 0),
            ec(this, "sliderWrapper", void 0),
            ec(this, "slideItems", void 0),
            ec(this, "allSlideItems", void 0),
            ec(this, "resizeTimeout", void 0),
            ec(this, "swiperTimeout", void 0),
            ec(this, "gpsLazy", void 0),
            ec(this, "isLoaded", !1),
            ec(this, "isReadyToInit", !1),
            ec(this, "carouselType", void 0),
            ec(this, "isInitializing", !1),
            ec(this, "handleGpLazyLoaded", () => {
                var e;
                this.isLoaded = !0,
                null === (e = this.gpsLazy) || void 0 === e || e.removeEventListener("GpLazyLoaded", this.handleGpLazyLoaded),
                this.init()
            }
            ),
            ec(this, "checkLayoutToInit", () => {
                this.getShouldInitByLayout() && (this.isReadyToInit = !0,
                window.removeEventListener("gp:debounceResize", this.checkLayoutToInit),
                this.init())
            }
            ),
            ec(this, "calculateCarouselTypeAndSetting", () => {
                var e, t, i;
                let s = this.getState("carouselType");
                if (s) {
                    this.carouselType = s;
                    return
                }
                let l = r.CAROUSEL
                  , n = null === (e = this.componentId) || void 0 === e ? void 0 : e.includes("product-list")
                  , a = (null === (t = this.closest(`.${ep}`)) || void 0 === t ? void 0 : t.getAttribute("type")) === ep
                  , o = null === (i = this.componentId) || void 0 === i ? void 0 : i.includes("ft-gp-carousel");
                a && (l = r.FEATURE_IMAGE_THUMBS),
                o && (l = r.FEATURE_IMAGE),
                n && (l = r.PRODUCT_LIST),
                this.carouselType = l
            }
            ),
            ec(this, "init", () => {
                var e, t;
                if (!this.isLoaded || !this.isReadyToInit || (this.componentId = this.getState("id"),
                !this.componentId))
                    return;
                this.setting = this.getState("setting"),
                this.styles = this.getState("styles"),
                this.sliderWrapper = this.querySelector(`#gp-carousel-${this.componentId} .${ef}`),
                this.isInitializing = !0,
                this.reQuerySlideItems(),
                this.calculateCarouselTypeAndSetting(),
                this.totalItems = null !== (t = null === (e = this.slideItems) || void 0 === e ? void 0 : e.length) && void 0 !== t ? t : 0,
                this.shouldSkipSlide = this.computeShouldSkipSlideWhenSneakPeekCenter(),
                this.isHiddenArrowWhenDisabled = this.getState("isHiddenArrowWhenDisabled"),
                el.use([en, eo, eh, ed]),
                this.duplicateSlidesForLoop();
                let i = this.getSliderOption();
                this.initResizeObserver();
                let s = this.querySelector(`#${ev}${this.componentId}`);
                if (!s) {
                    console.error("Swiper container not found");
                    return
                }
                this.allSlideItems = this.querySelectorAll(`#gp-carousel-${this.componentId} .${ew}-${this.componentId}`),
                this.swiperInstance = new el(s,i),
                this.watchSneakPeakCenter(this.swiperInstance),
                this.observeHostForRecovery(),
                this.swiperInstance.on("resize", () => {
                    this.swiperTimeout && clearTimeout(this.swiperTimeout),
                    this.swiperTimeout = setTimeout( () => {
                        this.swiperTimeout = void 0,
                        this.shouldSkipSlide = this.computeShouldSkipSlideWhenSneakPeekCenter(),
                        this.swiperInstance && this.watchSneakPeakCenter(this.swiperInstance);
                        let e = this.checkHideArrow();
                        this.checkHideDot(),
                        this.handleDuplicateSlidesCleanup(),
                        e || (this.duplicateSlidesForLoop(),
                        this.checkDisableArrowButton())
                    }
                    , 300)
                }
                ),
                this.checkDisableArrowButton(),
                this.renderSliderDots(),
                this.setGalleryThumbs(),
                this.onListenerChangeSlideInteraction();
                let l = this.querySelector(`.${ef}`);
                null == l || l.addEventListener("click", e => {
                    var t;
                    let i = null === (t = e.target.closest(`.${ew}`)) || void 0 === t ? void 0 : t.getAttribute("data-index");
                    this.dispatchEventSelectItem(Number(i))
                }
                ),
                setTimeout( () => {
                    this.isInitializing = !1
                }
                , 0)
            }
            ),
            ec(this, "getSlideToShowFromOldData", () => {
                var e;
                if (!(null === (e = this.setting) || void 0 === e ? void 0 : e.slidesToShow))
                    return null;
                let t = {};
                return a.forEach(e => {
                    var i;
                    let s = n(null === (i = this.setting) || void 0 === i ? void 0 : i.slidesToShow, e);
                    t[e] = s ? "auto" === s ? 4 : s : 1
                }
                ),
                t
            }
            ),
            ec(this, "getSlideToShow", () => {
                let e = {}
                  , t = this.getSlideToShowFromOldData();
                return t || (a.forEach(t => {
                    var i, s, l, r, a, o, d, h;
                    let p = n(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, t)
                      , u = p ? "center" === n(null === (s = this.setting) || void 0 === s ? void 0 : s.sneakPeakType, t) ? null !== (d = n(null === (l = this.setting) || void 0 === l ? void 0 : l.sneakPeakOffsetCenter, t)) && void 0 !== d ? d : 0 : null !== (h = n(null === (r = this.setting) || void 0 === r ? void 0 : r.sneakPeakOffsetForward, t)) && void 0 !== h ? h : 0 : 0
                      , c = n(null === (a = this.setting) || void 0 === a ? void 0 : a.itemNumber, t) || 0
                      , v = "center" === n(null === (o = this.setting) || void 0 === o ? void 0 : o.sneakPeakType, t) ? -2 : -1;
                    e[t] = "auto" === c ? c : c + u / 100 * v
                }
                ),
                e)
            }
            ),
            ec(this, "getNumberOfFullWidthShow", e => {
                var t, i, s;
                let l = "center" === n(null === this || void 0 === this ? void 0 : null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeakType, e) ? 2 : 1;
                return "number" == typeof n(null === (i = this.setting) || void 0 === i ? void 0 : i.itemNumber, e, 4) ? n(null === (s = this.setting) || void 0 === s ? void 0 : s.itemNumber, e, 4) - l : void 0
            }
            ),
            ec(this, "calculateSlidesOffset", e => {
                var t, i;
                let {slidesPerView: s, itemNumberByDevice: l, centeredSlides: r} = e;
                if (!r || !("number" == typeof l && l % 2 == 0))
                    return 0;
                let n = null !== (i = null === (t = this.sliderWrapper) || void 0 === t ? void 0 : t.clientWidth) && void 0 !== i ? i : 0
                  , a = n / s
                  , o = (Number(l) - 2) / 2 - 1;
                return -(a / 2 + o * a)
            }
            ),
            ec(this, "getItemsPerPage", () => {
                let {slidePerPage: e} = this.getSliderSetting()
                  , t = "auto" === e ? 1 : e;
                return null != t ? t : 1
            }
            ),
            ec(this, "getDotItems", () => {
                var e, t, i, s, l;
                let r = n(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, window.screenSize.getDeviceName(), !0)
                  , a = null !== (s = null === (t = this.allSlideItems) || void 0 === t ? void 0 : t.length) && void 0 !== s ? s : 0
                  , {slidePerPage: o} = this.getSliderSetting()
                  , d = null !== (l = this.getNumberOfFullWidthShow(window.screenSize.getDeviceName())) && void 0 !== l ? l : 1
                  , h = n(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, window.screenSize.getDeviceName());
                return Array.from({
                    length: r ? this.isDuplicatedSlides ? a / 2 : a : h ? a - d + 1 : "auto" === o ? 0 : Math.ceil(a / o)
                }, (e, t) => t)
            }
            ),
            ec(this, "getActiveIndexDot", (e, t, i) => e ? t : Math.ceil(t / i)),
            ec(this, "goToSlideByIndex", e => {
                var t, i, s, l, r, a, o, d, h, p, u, c, v, m, g, f, w, S, b, y, T, x, E;
                let {index: I, speed: C} = null != e ? e : {};
                if (void 0 === I)
                    return;
                if (this.filteredVisibleIndices) {
                    let e = n(null === (l = this.setting) || void 0 === l ? void 0 : l.loop, window.screenSize.getDeviceName(), !0);
                    e ? null === (r = this.swiperInstance) || void 0 === r || r.slideToLoop(I, C) : null === (a = this.swiperInstance) || void 0 === a || a.slideTo(I, C);
                    return
                }
                let k = window.screenSize.getDeviceName()
                  , P = n(null === (t = this.setting) || void 0 === t ? void 0 : t.loop, k, !0)
                  , M = (null === (s = this.setting) || void 0 === s ? void 0 : null === (i = s.sneakPeak) || void 0 === i ? void 0 : i[k]) ? I : P ? I : this.getIndexSlideItemBy(I);
                if (P) {
                    let e = "number" == typeof n(null === (o = this.setting) || void 0 === o ? void 0 : o.itemNumber, k) ? Math.ceil(n(null === (d = this.setting) || void 0 === d ? void 0 : d.itemNumber, k)) : this.getSlidesPerViewDynamic();
                    if (this.totalItems < e) {
                        null === (S = this.swiperInstance) || void 0 === S || S.slideTo(M, C);
                        return
                    }
                    if ((null === (h = this.swiperInstance) || void 0 === h ? void 0 : h.realIndex) === M)
                        return;
                    if (M === Number(null === (p = this.swiperInstance) || void 0 === p ? void 0 : p.realIndex) + 1 || 0 === M && (null === (u = this.swiperInstance) || void 0 === u ? void 0 : u.realIndex) === this.totalItems - 1)
                        return null === (b = this.swiperInstance) || void 0 === b ? void 0 : b.slideNext(C);
                    if (M === Number(null === (c = this.swiperInstance) || void 0 === c ? void 0 : c.realIndex) - 1 || M === this.totalItems - 1 && (null === (v = this.swiperInstance) || void 0 === v ? void 0 : v.realIndex) === 0)
                        return null === (y = this.swiperInstance) || void 0 === y ? void 0 : y.slidePrev(C);
                    let t = n(null === (m = this.setting) || void 0 === m ? void 0 : m.sneakPeak, k, !1) && "center" === n(null === (g = this.setting) || void 0 === g ? void 0 : g.sneakPeakType, k) && "number" == typeof n(null === (f = this.setting) || void 0 === f ? void 0 : f.itemNumber, k) && Number(n(null === (w = this.setting) || void 0 === w ? void 0 : w.itemNumber, k)) % 2 == 0;
                    t ? null === (T = this.swiperInstance) || void 0 === T || T.slideToLoopCenterSneakPeek(M, C) : null === (x = this.swiperInstance) || void 0 === x || x.slideToLoop(M, C)
                } else
                    null === (E = this.swiperInstance) || void 0 === E || E.slideTo(this.shouldSkipSlide ? M + this.skipSlideCount : M, C)
            }
            ),
            ec(this, "handleSlideNavigation", e => {
                var t, i, s, l;
                let {isRollback: r, isNext: n} = e;
                r ? n ? null === (t = this.swiperInstance) || void 0 === t || t.slidePrev() : null === (i = this.swiperInstance) || void 0 === i || i.slideNext() : n ? null === (s = this.swiperInstance) || void 0 === s || s.slideNext() : null === (l = this.swiperInstance) || void 0 === l || l.slidePrev()
            }
            ),
            ec(this, "reinitializeSwiper", e => {
                if (!this.isReadyToInit)
                    return;
                let t = this.querySelector(`#${ev}${this.componentId}`);
                if (t) {
                    let i = this.getSliderOption();
                    this.swiperInstance = new el(t,i);
                    let s = Math.max(0, Math.min(e, this.totalItems - 1));
                    this.goToSlideByIndex({
                        index: s
                    })
                }
            }
            ),
            ec(this, "updateSliderAfterFilter", (e=0) => {
                var t, i;
                if (this.swiperInstance && (this.swiperInstance.destroy(!0, !0),
                this.swiperInstance = void 0),
                this.isDuplicatedSlides && this.sliderWrapper) {
                    let e = this.sliderWrapper.querySelectorAll('[data-duplicate="true"]');
                    e.forEach(e => e.remove()),
                    this.isDuplicatedSlides = !1
                }
                this.reQuerySlideItems(),
                this.totalItems = null !== (i = null === (t = this.slideItems) || void 0 === t ? void 0 : t.length) && void 0 !== i ? i : 0,
                this.reQuerySliderWrapper(),
                this.duplicateSlidesForLoop(),
                this.reQueryAllSlideItems(),
                this.reinitializeSwiper(e);
                let s = this.totalItems > 0 ? e : 0;
                this.setAttribute("active-index", String(s));
                let l = new Event("changeActiveIndex");
                this.dispatchEvent(l),
                this.reRenderSliderAfterFilter(s),
                this.updateDotClickEvent()
            }
            ),
            ec(this, "recheckNavigation", () => {
                var e, t, i;
                this.reQuerySlideItems(),
                this.totalItems = null !== (i = null === (e = this.slideItems) || void 0 === e ? void 0 : e.length) && void 0 !== i ? i : 0,
                null === (t = this.swiperInstance) || void 0 === t || t.update(),
                this.checkHideArrow(),
                this.checkDisableArrowButton()
            }
            ),
            ec(this, "reRenderSliderAfterFilter", e => {
                this.getDotContainer(),
                this.dotContainer && this.dotContainer.style.removeProperty("display"),
                this.renderSliderDots(e),
                this.checkHideDot()
            }
            ),
            ec(this, "onListenerChangeSlideInteraction", () => {
                if (!this.onTrigger || !this.swiperInstance)
                    return;
                let e = e => {
                    var t;
                    let i = (null === (t = this.swiperInstance) || void 0 === t ? void 0 : t.activeIndex) || 0;
                    return e && o(this, e, i.toString()),
                    i
                }
                ;
                this.onTrigger({
                    event: "gp:change-previous-slide"
                }, t => {
                    let {isRollback: i, uniqueStorageKey: s} = t || {};
                    e(s),
                    this.handleSlideNavigation({
                        isRollback: i,
                        isNext: !1
                    })
                }
                ),
                this.onTrigger({
                    event: "gp:change-next-slide"
                }, t => {
                    let {isRollback: i, uniqueStorageKey: s} = t || {};
                    e(s),
                    this.handleSlideNavigation({
                        isRollback: i,
                        isNext: !0
                    })
                }
                ),
                this.onTrigger({
                    event: "gp:change-index-slide"
                }, t => {
                    let {uniqueStorageKey: i, data: s} = t || {};
                    e(i);
                    let l = Number(s);
                    if (!isNaN(l)) {
                        var r;
                        null === (r = this.swiperInstance) || void 0 === r || r.slideTo(l)
                    }
                }
                )
            }
            )
        }
    }
    let eT = () => {
        window.removeEventListener("gp-global-loaded", eT),
        customElements.get("gp-carousel-v3") || customElements.define("gp-carousel-v3", ey)
    }
    ;
    "completed" === window.gpReadyState ? eT() : window.addEventListener("gp-global-loaded", eT),
    e.GPCarousel = ey
}({});
